<template>
  <div :key="updateDisplay">
    <!-- hidden modal to show when wanting to edit a links set (people, documents, contacts) -->
    <el-dialog
      center
      :title="modalTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.links"
    >
      <!-- can put 'cards' or other layouts as needed here -->
      <edit-links-card
        :context="modalContext"
        :links="links"
        :key="modalInfo.key"
        :isModal="true"
        @edit-links-card-close="closeModal"
      ></edit-links-card>
    </el-dialog>
    <!-- dialog w/ a single text area -->
    <el-dialog
      center
      :title="modalTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.notes"
    >
      <edit-text-area-card
        :context="modalContext"
        :text="textArea"
        :isModal="true"
        @edit-text-area-card-close="closeModal"
      ></edit-text-area-card>
    </el-dialog>
    <!-- dialog w/ company information -->
    <el-dialog
      center
      :title="modalTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.company"
    >
      <edit-company-card
        :context="modalContext"
        :company="currentCompany"
        :isModal="true"
        @editable-company-card-close="closeModal"
      ></edit-company-card>
    </el-dialog>
    <!-- dialog to edit investment/portfolio info for a company -->
    <el-dialog
      center
      :title="modalTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.investmentinfo"
    >
      <edit-investment-info-card
        :context="modalContext"
        :title="modalTitle"
        :portfolio="edit[CONSTANTS.INVESTMENTINFO]"
        :isModal="true"
        @edit-investment-info-card-close="closeModal"
      ></edit-investment-info-card>
    </el-dialog>
    <!-- confirm delete -->
    <el-dialog
      center
      :title="modalTitleConfirm"
      :context="modalContext"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.deleteprompt"
    >
      <confirm-card
        :context="modalContext"
        @confirm-card-close="closeModal"
      ></confirm-card>
    </el-dialog>
    <!--<h2>ACME Company</h2>
    <p>All about ACME!</p>-->
    <!--Company Test Card-->

    <div id="capture" class="capture">
      <div
        class="row m-0"
        style="
          padding-left: 15px;
          padding-right: 15px;
          padding-top: 15px;
          justify-content: space-between;
        "
      >
        <div class="d-flex">
          <div
            class="d-flex mr-3"
            v-if="referralsData && referralsData.name"
            style="margin-left: 5px"
          >
            <div class="mr-1">Referred by:</div>
            <span style="color: #757575; text-transform: capitalize">{{
              referralsData.name
            }}</span>
          </div>
          <div
            class="d-flex"
            v-if="
              currentCompany &&
                currentCompany.tags &&
                currentCompany.tags.length > 0
            "
          >
            <div>Tags:</div>
            <div
              v-for="(item, index) in currentCompany.tags"
              class="badge px-2 ml-2 companyTagCls"
              :key="index"
            >
              <div
                class="d-flex"
                style="
                  margin-top: 2px;
                  color: #0000009a;
                  font-weight: lighter !important;
                "
              >
                <div>{{ item }}</div>
                <div>
                  <i
                    class="fa fa-times"
                    style="cursor: pointer"
                    @click="removeTag(item, index)"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex"
          @click="
            shareCompanyModalShow = true;
            refreshForm = true;
          "
          style="cursor: pointer"
          v-if="currentCompany && currentCompany.permalink"
        >
          <div class="mr-2" style="margin-top: -5px">
            <i
              class="fas fa-share-alt user-font"
              aria-hidden="true"
              style="font-size: 14px"
            ></i>
          </div>
          <div class="companyProfileShareCompanyText">Share Company</div>
        </div>
      </div>
      <div
        class="row"
        style="padding-left: 15px; padding-right: 15px; padding-top: 15px"
      >
        <div class="col-md-3" style="/*width:260px;*/">
          <company-card
            :data="currentCompany"
            :portfolio="portfolio"
            :offerings="offerings"
            :downloadProps="downloadProps"
            :people="people"
            :referrals="referralsData"
            @company-save="getReferrers"
            @notes-save="refreshNotesCard"
            @investment-save="refreshInvestmentsData"
            ref="companyCard"
          >
            <template slot="header"></template>
            <template slot="footer"></template>
          </company-card>
        </div>
        <!-- <div :class="righttable"> -->
        <div
          class="col-md-9"
          style="/*width:calc(100% - 260px)*/ padding-left: 0px"
        >
          <card
            class="invst width-100"
            style="min-height: 108px; margin-bottom: 15px"
            title=""
            v-if="
              currentCompany &&
                [
                  'Acquired',
                  'In-Active',
                  'Out of Business',
                  'Unknown'
                ].includes(currentCompany.status) &&
                currentCompany.acquisition_info
            "
          >
            <div>
              <div class="row">
                <div class="col-11">
                  <div class="acquired-company-pill">
                    <span>
                      Acquired By
                      <span @click="openAcquisitionCompany()" class="link"
                        >{{
                          currentCompany.acquisition_info
                            .acquisitionAquiringCompanyName
                        }}
                      </span>
                    </span>
                  </div>
                </div>
                <div class="col-1 text-right">
                  <i
                    class="fa fa-pencil link"
                    @click="handleAcquisitionEdit()"
                    title="Edit"
                    v-if="statusChangePermission()"
                  ></i>
                </div>
              </div>
              <div>
                <b>Acquisition</b>
              </div>
              <div class="flex-row">
                <div
                  class="info-section"
                  v-if="
                    currentCompany.acquisition_info.acquisitionType ===
                      'cash' ||
                      currentCompany.acquisition_info.acquisitionType === 'mix'
                  "
                >
                  <div
                    class="flex-row"
                    v-if="
                      currentCompany.acquisition_info.acquisitionType ===
                        'cash' ||
                        currentCompany.acquisition_info.acquisitionType ===
                          'mix'
                    "
                  >
                    <div class="label">Cash Proceeds</div>

                    <div class="value">
                      {{
                        formatCurrency(
                          currentCompany.acquisition_info
                            .acquisitionCashProceeds,
                          currency.ref
                        )
                      }}
                    </div>
                  </div>

                  <div
                    class="flex-row"
                    v-if="
                      currentCompany.acquisition_info.acquisitionType ===
                        'cash' ||
                        currentCompany.acquisition_info.acquisitionType ===
                          'mix'
                    "
                  >
                    <div class="label">Recycle $</div>

                    <div class="value">
                      {{
                        formatCurrency(
                          currentCompany.acquisition_info.acquisitionRecycle,
                          currency.ref
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex-row"
                    v-if="
                      currentCompany.acquisition_info.acquisitionType ===
                        'cash' ||
                        currentCompany.acquisition_info.acquisitionType ===
                          'mix'
                    "
                  >
                    <div class="label">Distribution</div>

                    <div class="value">
                      {{
                        formatCurrency(
                          currentCompany.acquisition_info
                            .acquisitionDistribution,
                          currency.ref
                        )
                      }}
                    </div>
                  </div>
                </div>
                <span
                  class="flex-auto"
                  v-if="
                    currentCompany.acquisition_info.acquisitionType ===
                      'cash' ||
                      currentCompany.acquisition_info.acquisitionType === 'mix'
                  "
                ></span>
                <div>
                  <div class="info-section">
                    <div
                      class="flex-row"
                      v-if="
                        currentCompany.acquisition_info.acquisitionType ===
                          'stock' ||
                          currentCompany.acquisition_info.acquisitionType ===
                            'mix'
                      "
                    >
                      <div class="label"># Of Shares</div>

                      <div class="value">
                        {{
                          currentCompany.acquisition_info
                            .acquisitionSharesIssued
                        }}
                      </div>
                    </div>
                    <div
                      class="flex-row"
                      v-if="
                        currentCompany.acquisition_info.acquisitionType ===
                          'stock' ||
                          currentCompany.acquisition_info.acquisitionType ===
                            'mix'
                      "
                    >
                      <div class="label">PPS</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.acquisition_info
                              .acquisitionPricePerShare,
                            currency.ref
                          ) || 0
                        }}
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="label">Transaction Date</div>

                      <div class="value">
                        {{
                          moment(
                            currentCompany.acquisition_info
                              .acquisitionTransactionDate
                          ).format("MM/DD/YYYY")
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>

          <card
            class="invst width-100"
            style="min-height: 108px; margin-bottom: 15px"
            v-if="
              currentCompany &&
                ['IPO', 'In-Active', 'Out of Business', 'Unknown'].includes(
                  currentCompany.status
                ) &&
                currentCompany.ipo_info
            "
          >
            <div>
              <div class="flex-row">
                <div class="info-section">
                  <div
                    class="flex-row"
                    v-if="currentCompany.ipo_info.ipoSoldShare === 'No'"
                  >
                    <div class="label"># of shares I am holding</div>

                    <div class="value">
                      {{
                        currentCompany.ipo_info.ipoNumberOfSharesYouHold || 0
                      }}
                    </div>
                  </div>

                  <div
                    class="flex-row"
                    v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                  >
                    <div class="label"># of shares</div>

                    <div class="value">
                      {{ currentCompany.ipo_info.ipoNumberOfShares }}
                    </div>
                  </div>

                  <div class="flex-row">
                    <div class="label">Current Trading PPS</div>
                    <span class="flex-auto"></span>
                    <div class="value">
                      {{
                        currentCompany.currentTradingPricePerShare || "Unknown"
                      }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="label">Internal Book Value Per Share</div>

                    <div class="value">
                      {{ currentCompany.bookValuePerShare || "Unknown" }}
                    </div>
                  </div>
                </div>
                <span class="flex-auto"></span>
                <div class="text-right">
                  <i
                    class="fa fa-pencil link"
                    @click="handleIpoEdit()"
                    title="Edit"
                    v-if="statusChangePermission()"
                  ></i>
                  <div>
                    Have you sold your shares?

                    <!-- <span class="required">*</span> -->
                  </div>

                  <div class="radio-wrapper">
                    <l-radio
                      disabled="true"
                      v-bind:groupname="'sold'"
                      v-model="currentCompany.ipo_info.ipoSoldShare"
                      value="yes"
                      label="Yes"
                      >Yes</l-radio
                    >
                    <l-radio
                      disabled="true"
                      v-bind:groupname="'sold'"
                      v-model="currentCompany.ipo_info.ipoSoldShare"
                      value="no"
                      label="No"
                      >No</l-radio
                    >
                  </div>
                </div>
              </div>
            </div>
          </card>

          <!-- <div class="equal-column"> -->
          <div class>
            <!-- <card class="contacts-card invst" style="height: 108px;"> -->
            <card class="invst" style="min-height: 108px; margin-bottom: 15px">
              <!-- <h4 class="card-title" style="margin-bottom: 10px;">Current Investment Status</h4> -->
              <div
                class="invst-wrp companyProfileInvestmentDetailsLayout"
                v-if="
                  currentCompany &&
                    currentCompany.user_investment_status != 'Diligence'
                "
              >
                <!-- <div class="invst-box">
                  <div class="invst-label">My Ownership</div>
                  <div class="invst-val flex-center">{{portfolioOwnership}}</div>
                </div>-->
                <!-- <div > -->
                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    My Ownership
                  </div>
                  <div class="companyProfileInvestmentDetailsValue">
                    {{ portfolioOwnership }}
                  </div>
                </div>

                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    My Cost
                  </div>
                  <div class="companyProfileInvestmentDetailsValue">
                    {{getOverallInvestments.totalInvestment ? getOverallInvestments.totalInvestment:0 }}
                  </div>
                </div>

                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Current Value
                  </div>
                  <div class="companyProfileInvestmentDetailsValue">
                    {{ getOverallInvestments.totalCurrentValue?getOverallInvestments.totalCurrentValue:0 }}
                  </div>
                </div>

                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Multiple
                  </div>
                  <div class="companyProfileInvestmentDetailsValue">
                    {{ getOverallInvestments.totalGainPercent?getOverallInvestments.totalGainPercent:0 }}
                  </div>
                </div>

                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Gain/Loss
                  </div>
                  <div class="companyProfileInvestmentDetailsValue">
                    <span>{{ getOverallInvestments.totalGain?getOverallInvestments.totalGain:0 }}</span>
                    <i
                      class="companyProfileInvestmentDetailsAmountArrow fa fa-sm"
                      :class="{
                        'fa-arrow-down companyProfileInvestmentDetailsAmountArrowDownColor':
                          getOverallInvestments.totalGainPercent <= 0,
                        'fa-arrow-up companyProfileInvestmentDetailsAmountArrowUpColor':
                          getOverallInvestments.totalGainPercent > 0
                      }"
                    ></i>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="invst-wrp companyProfileInvestmentDetailsLayout"
              >
                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Current Round
                  </div>
                  <div
                    class="companyProfileInvestmentDetailsValue"
                    style="font-size: 16px"
                  >
                    <el-select
                      class="select-primary dilignce-el-select dilignce-el-select1"
                      size="small"
                      placeholder="Select Current Round"
                      :disabled="!checkDiligenceRound"
                      v-if="currentCompany"
                      v-model="currentCompany.stage"
                      @change="changeDealRound"
                    >
                      <el-option
                        class="select-primary"
                        v-for="option in vals.STAGE_DEFINES"
                        :value="option"
                        :label="option"
                        :key="option"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Diligence Stage
                  </div>
                  <div
                    class="companyProfileInvestmentDetailsValue"
                    style="font-size: 16px"
                  >
                    <el-select
                      class="select-primary dilignce-el-select"
                      size="small"
                      v-if="currentCompany"
                      v-model="currentCompany.deal_stage"
                      :disabled="!checkDiligenceStage"
                      @change="noteModalShow"
                    >
                      <el-option
                        class="select-primary"
                        v-for="option in diligenceStageList"
                        :value="option._id"
                        :label="option.stage_name"
                        :key="option._id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class>
                  <div class="companyProfileInvestmentDetailsLabel">
                    Referred By
                  </div>
                  <div
                    class="companyProfileInvestmentDetailsValue"
                    style="font-size: 16px; text-transform: capitalize"
                  >
                    {{
                      referralsData && referralsData.name
                        ? referralsData.name
                        : "-"
                    }}
                    <!-- <span
                      v-if="referralsData.length > 1"
                      class="ml-2"
                      style="background-color: #CBCBCB;border-radius: 5px;cursor:pointer"
                      id="referralsId"
                    >
                      +{{referralsData.length-1}}
                      <b-popover target="referralsId" triggers="hover" placement="topleft">
                        <div
                          style="font-size: 16px;text-transform: capitalize;"
                          v-for="(item,index) in referralsData"
                          :key="index"
                        >
                          <span v-if="index !=0">{{item.name}}</span>
                        </div>
                      </b-popover>
                    </span>-->
                  </div>
                </div>
              </div>
            </card>

            <card
              class="invst width-100"
              style="min-height: 108px; margin-bottom: 15px"
              title=""
              v-if="currentCompany && currentCompany.acquired_company_info"
            >
              <div>
                <div class="row">
                  <div class="acquired-company-pill">
                    <span>
                      shares issued by acquisition of
                      <span
                        @click="
                          openAcquiredCompany(
                            currentCompany.acquired_company_info
                              .acquisitionAcquiredCompanyUcId
                          )
                        "
                        class="link"
                        >{{
                          currentCompany.acquired_company_info
                            .acquisitionAcquiredCompanyName
                        }}
                      </span>
                    </span>
                  </div>
                </div>
                <div>
                  <b>Acquisition</b>
                </div>
                <div class="flex-row">
                  <div class="info-section">
                    <div
                      class="flex-row"
                      v-if="
                        currentCompany.acquired_company_info.acquisitionType ===
                          'cash' ||
                          currentCompany.acquired_company_info
                            .acquisitionType === 'mix'
                      "
                    >
                      <div class="label">Cash Proceeds</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.acquired_company_info
                              .acquisitionCashProceeds,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>

                    <div
                      class="flex-row"
                      v-if="
                        currentCompany.acquired_company_info.acquisitionType ===
                          'cash' ||
                          currentCompany.acquired_company_info
                            .acquisitionType === 'mix'
                      "
                    >
                      <div class="label">Recycle $</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.acquired_company_info
                              .acquisitionRecycle,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="flex-row"
                      v-if="
                        currentCompany.acquired_company_info.acquisitionType ===
                          'cash' ||
                          currentCompany.acquired_company_info
                            .acquisitionType === 'mix'
                      "
                    >
                      <div class="label">Distribution</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.acquired_company_info
                              .acquisitionDistribution,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <span class="flex-auto"></span>
                  <div>
                    <div class="info-section">
                      <div
                        class="flex-row"
                        v-if="
                          currentCompany.acquired_company_info
                            .acquisitionType === 'stock' ||
                            currentCompany.acquired_company_info
                              .acquisitionType === 'mix'
                        "
                      >
                        <div class="label"># Of Shares</div>

                        <div class="value">
                          {{
                            currentCompany.acquired_company_info
                              .acquisitionSharesIssued
                          }}
                        </div>
                      </div>
                      <div
                        class="flex-row"
                        v-if="
                          currentCompany.acquired_company_info
                            .acquisitionType === 'stock' ||
                            currentCompany.acquired_company_info
                              .acquisitionType === 'mix'
                        "
                      >
                        <div class="label">PPS</div>

                        <div class="value">
                          ${{
                            currentCompany.acquired_company_info
                              .acquisitionPricePerShare || 0
                          }}
                        </div>
                      </div>
                      <div class="flex-row">
                        <div class="label">Transaction Date</div>

                        <div class="value">
                          {{
                            moment(
                              currentCompany.acquired_company_info
                                .acquisitionTransactionDate
                            ).format("MM/DD/YYYY")
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>

            <card
              class="invst width-100"
              style="min-height: 108px; margin-bottom: 15px"
              title="IPO"
              v-if="
                currentCompany &&
                  ['IPO', 'In-Active', 'Out of Business', 'Unknown'].includes(
                    currentCompany.status
                  ) &&
                  currentCompany.ipo_info
              "
            >
              <div>
                <div
                  class="floating-text"
                  v-if="currentCompany.ipo_info.ipoSoldShare === 'No'"
                >
                  <i
                    class="fa fa-clock-o"
                    style="margin-right: 5px; color: #593bfd"
                    aria-hidden="true"
                  ></i>
                  <b>
                    Lock Up Period :
                    {{ calculateLockupDaysRemaining(currentCompany.ipo_info) }}
                    days
                  </b>
                </div>
                <div class="flex-row">
                  <div class="info-section">
                    <div
                      class="flex-row"
                      v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                    >
                      <div class="label">Total Proceeds</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.ipo_info.ipoTotalProceeds,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="flex-row"
                      v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                    >
                      <div class="label">Recycle $</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.ipo_info.ipoRecycled,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="flex-row"
                      v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                    >
                      <div class="label">Distribution</div>

                      <div class="value">
                        {{
                          formatCurrency(
                            currentCompany.ipo_info.ipoDistribution,
                            currency.ref
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <span
                    class="flex-auto"
                    v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                  ></span>
                  <div>
                    <div class="info-section">
                      <div class="flex-row">
                        <div class="label">PPS</div>

                        <div class="value">
                          {{
                            formatCurrency(
                              currentCompany.ipo_info.ipoPricePerShare,
                              currency.ref
                            ) || 0
                          }}
                        </div>
                      </div>
                      <div
                        class="flex-row"
                        v-if="currentCompany.ipo_info.ipoSoldShare === 'Yes'"
                      >
                        <div class="label">Date Sold</div>

                        <div class="value">
                          {{
                            moment(currentCompany.ipo_info.ipoDateSold).format(
                              "MM/DD/YYYY"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>

            <tabulator-card
              id="theMainTableBoxMyInvestments"
              v-if="
                currentCompany &&
                  currentCompany.user_investment_status != 'Diligence'
              "
              :tableData="myInvestments.data"
              :tableOptions="myInvestments.options"
              :tableColumns="myInvestments.columns"
              @tabulatorDetails="getInvestmentTabulatorDetails"
              class="todos-table-parent companyProfileTabulatorLayout companyProfileTabulatorInvestFundTable"
              style="min-height: 215px; margin-bottom: 15px"
            >
              <template slot="header">
                <div class="d-flex">
                  <div
                    class="flex-grow-1 card-title companyProfileTabulatorTitle"
                  >
                    My Investments
                  </div>
                  <div
                    class="d-flex companyProfileCardsAddButton"
                    @click="handleCreateInvestment"
                    v-if="showInvestmentAdd"
                  >
                    <div>
                      <i class="fa fa-plus" style="font-size: 8px"></i>
                    </div>
                    <div>Add</div>
                  </div>
                </div>
                <!-- <span class="traction-line" v-if="myInvestmentPhrase">{{myInvestmentPhrase}}</span> -->
                <div class="companyProfileTabulatorTitleBorderLine"></div>
              </template>
            </tabulator-card>
            <tabulator-card
              id="theMainTableBoxMyValutaions"
              v-if="
                currentCompany &&
                  currentCompany.user_investment_status != 'Diligence'
              "
              :tableData="myValuations.data"
              :tableOptions="myValuations.options"
              :tableColumns="myValuations.columns"
              @tabulatorDetails="getValuationTabulatorDetails"
              class="todos-table-parent companyProfileTabulatorLayout companyProfileTabulatorInvestFundTable"
              style="min-height: 215px; margin-bottom: 15px"
            >
              <template slot="header">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="d-flex card-title companyProfileTabulatorTitle">
                      <div class>Rounds</div>
                      <div style="margin-left: 10px">
                        <div
                          class="valuationRaisedToDate"
                          style="padding-top: 3.5px"
                        >
                          Raised to date - {{ valuationRaiseToData }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex companyProfileCardsAddButton"
                    @click="handleCreateValuation"
                    v-if="showRoundsAdd"
                  >
                    <div>
                      <i class="fa fa-plus" style="font-size: 8px"></i>
                    </div>
                    <div>Add</div>
                  </div>
                </div>
                <!-- <span class="traction-line" v-if="myInvestmentPhrase">{{myInvestmentPhrase}}</span> -->
                <div class="companyProfileTabulatorTitleBorderLine"></div>
              </template>
            </tabulator-card>

            <tabulator-card
              id="theMainTableBoxFundingRounds"
              :tableData="fundingRounds.data"
              :tableOptions="fundingRounds.options"
              :tableColumns="fundingRounds.columns"
              class="todos-table-parent companyProfileTabulatorLayout companyProfileTabulatorInvestFundTable"
              style="min-height: 215px; margin-bottom: 15px"
            >
              <template slot="header">
                <div class="d-flex">
                  <div>
                    <h4 class="card-title companyProfileTabulatorTitle" style>
                      Funding Rounds
                    </h4>
                  </div>
                  <div style="margin-left: 16px">
                    <div style="padding-top: 10px">
                      <img
                        src="static/img/crunchBaseLogo.svg"
                        height="10px"
                        class
                      />
                    </div>
                  </div>
                </div>
                <!-- <span class="traction-line" v-if="offeringFundPhase">{{offeringFundPhase}}</span> -->
                <div class="companyProfileTabulatorTitleBorderLine"></div>
              </template>
            </tabulator-card>
            <div class>
              <!-- <div
                class="row"
                style="margin:0"
                v-if="portfolioTractionData && portfolioTractionData.length > 0"
              >
                <div class="col-6" style="padding-left: 0;">
                  <mrrKpiChart></mrrKpiChart>
                </div>
                <div class="col-6" style="padding-left:0;padding-right: 0;">
                  <churnKpiChart></churnKpiChart>
                </div>
              </div>-->
              <div
                class="row"
                style="margin: 0"
                v-if="portfolioTractionData && portfolioTractionData.length > 0"
              >
                <div class="col-md-12 pl-0 pr-0">
                  <div
                    class="card"
                    style="border-radius: 8px; margin-bottom: 15px"
                  >
                    <div class="card-header" style="padding-top: 0px">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <div class style>
                            <h4 class="card-title companyProfileTabulatorTitle">
                              KPI Graph's
                            </h4>
                          </div>
                        </div>
                        <div v-if="tractionLastUpdatedDate.length > 0">
                          <div
                            class="card-title companyProfileTabulatorTitle"
                            style="font-size: 12px"
                          >
                            Last updated date : {{ tractionLastUpdatedDate }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="col-md-6 pl-0">
                        <mrrKpiChart></mrrKpiChart>
                      </div>
                      <div class="col-md-6 pl-0 pr-0">
                        <churnKpiChart></churnKpiChart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="barChart"
                v-if="
                  portfolioTractionData && portfolioTractionData.length == 0
                "
              >
                <bar-company-comparison-chart-card
                  v-if="currentCompany"
                  :companyName="currentCompany.name"
                  defaultSelected="sector"
                ></bar-company-comparison-chart-card>
              </div>
            </div>

            <card title="" style="min-height: 261px" class="checklist-card">
              <div class="d-flex">
                <div
                  class="flex-grow-1 card-title companyProfileTabulatorTitle"
                >
                  Checklist
                </div>
                <div
                  class="d-flex companyProfileCardsAddButton"
                  @click="handleCreateChecklist"
                >
                  <div>
                    <i class="fa fa-plus" style="font-size: 8px"></i>
                  </div>
                  <div>Add</div>
                </div>
              </div>
              <!-- <span class="traction-line" v-if="myInvestmentPhrase">{{myInvestmentPhrase}}</span> -->
              <div class="companyProfileTabulatorTitleBorderLine"></div>

              <div class="list">
                <div
                  class="checklist-row"
                  v-for="(checklist, idx) in portfolioChecklist"
                  :key="idx"
                >
                  <div class="flex-row summary">
                    <div>
                      <checklist-name :index="`checklist${idx}`" :checklist="checklist" @refresh="getChecklistByPortfolio" :isDetails="false" :currentCompany="currentCompany"></checklist-name>
                      <!-- <div class="flex-row name-wrapper">
                        <div
                          class="name pointer"
                          @click="handleChecklistNameClick(checklist)"
                        >
                          {{ checklist.name }}
                        </div>
                        <div v-if="editName">
                          <form>
                            <input type="text" :value="checklist.name" />
                          </form>
                        </div>
                        <div v-if="!editName" class="editChecklistNameButton pointer" @click="toggleEditChecklistName">
                          <i class="far fa-edit"></i>
                        </div>
                        <div class="date">
                          {{
                            moment(checklist.created).format(
                              "MM-DD-YYYY hh:mm A"
                            )
                          }}
                        </div>
                      </div> -->
                      <div class="count">
                        {{
                          completedChecklistItemCount(checklist.checklist_items)
                        }}
                        / {{ checklist.checklist_items.length }} Completed
                      </div>
                    </div>

                    <span class="flex-auto"></span>

                    <div class="progress-wrapper">
                      <div class="progress-outer">
                        <div
                          class="progress"
                          v-bind:style="{
                            width:
                              (completedChecklistItemCount(
                                checklist.checklist_items
                              ) *
                                100) /
                                (checklist.checklist_items.length || 1) +
                              '%'
                          }"
                        >
                          {{
                            Math.ceil(
                              (completedChecklistItemCount(
                                checklist.checklist_items
                              ) *
                                100) /
                                (checklist.checklist_items.length || 1)
                            ) + "%"
                          }}
                        </div>
                      </div>
                    </div>
                    <el-dialog
                      center
                      width="400px"
                      :closeOnClickModal="false"
                      :closeOnPressEscape="false"
                      :showClose="true"
                      :visible.sync="deleteChecklist"
                    >
                      <div
                        class="row"
                        style="padding-left: 15px; padding-right: 15px"
                      >
                        <div style="padding-left: 30px">
                          Are you sure you want to delete this Checklist?
                        </div>
                      </div>
                      <div class="col-12 d-flex">
                        <div
                          class="col-xl edit-company-action-button-row"
                          style="padding-right: 25px"
                        >
                          <button
                            type="button"
                            class="todo-form-cancel-button btn-outline-secondary"
                            @click.prevent="handleCancelDeleteChecklist"
                          >
                            Cancel
                          </button>
                          <button
                            @click="handleDeleteChecklist(checklist)"
                            class="todo-form-submit-button btn btn-primary"
                            style="height: 35px"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </el-dialog>
                    <div
                      class="delete"
                      @click="deleteChecklistModal(checklist)"
                    >
                      <i class="fa fa-trash-alt pointer"></i>
                    </div>
                    <div class="arrows">
                      <i
                        class="fa fa-chevron-down pointer"
                        v-if="!checklist.show"
                        @click="toggleChecklist(checklist)"
                      ></i>
                      <i
                        class="fa fa-chevron-up pointer"
                        v-if="checklist.show"
                        @click="toggleChecklist(checklist)"
                      ></i>
                    </div>
                  </div>

                  <div class="details" v-if="checklist.show">
                    <div v-if="!checklist.checklist_items.length">
                      <i class="no-data-msg">no checklist items added yet</i>
                    </div>
                    <div
                      class="checklist-item-row flex-row"
                      v-for="(item, itmIdx) in checklist.checklist_items"
                      :key="itmIdx"
                    >
                      <div class="checkbox">
                        <b-spinner
                          v-if="showSaveCheck && item.id == currentItemId"
                          style="float: right"
                          small
                          label="Loading..."
                        ></b-spinner>
                        <i
                          class="fa fa-square-o pointer"
                          @click="handleCheck(item, checklist, true)"
                          v-if="!item.is_done && item.id != currentItemId"
                        ></i>
                        <i
                          class="fa fa-check-square pointer"
                          @click="handleCheck(item, checklist, false)"
                          v-if="item.is_done && item.id != currentItemId"
                        ></i>
                      </div>
                      <div v-html="item.summary" class="checklist-item"></div>
                      <span class="flex-auto"></span>
                      <div class="comment-total">
                        <i class="fa fa-comment-o"></i>
                        {{ item.discussions.length }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>

            <!-- <div v-if="portfolioTractionData && portfolioTractionData.length > 0">
              <div>
                <churnKpiChart></churnKpiChart>
              </div>
            </div>-->
            <div class="row" style="margin: 0">
              <div class="col-6" style="padding-left: 0">
                <documentsCard
                  :data="{ attachments }"
                  :portfolioItem="currentCompany"
                  context="companyProfile"
                  v-if="refreshDocuments"
                ></documentsCard>
              </div>
              <div class="col-6" style="padding-left: 0; padding-right: 0">
                <notesCard
                  v-if="refreshNotes"
                  ref="noteRef"
                  :data="{ currentCompany }"
                ></notesCard>
              </div>
            </div>
            <div>
              <newsFeedCard
                :newsFeedList="newsFeedList"
                context="Profile"
              ></newsFeedCard>
            </div>
            <div
              class="card chart-card"
              style="
                max-width: 300px;
                max-height: 475px;
                overflow: auto;
                margin-bottom: 30px;
                height: 323px;
              "
            >
              <twitter v-if="currentCompany">
                <a class="twitter-timeline" :href="currentCompany.twitter"></a>
              </twitter>
            </div>
          </div>
        </div>
      </div>
    </div>

    <dialogfundingrounddetails
      v-model="dialogFundingRoundData"
    ></dialogfundingrounddetails>

    <DialogAddInvestmentForm
      v-if="currentCompany"
      :organization="currentCompany ? currentCompany.organization : ''"
      :contactEmail="contactEmailString"
      :investmentData="rowInvestmentData"
      :lastFundingRoundDate="lastFundingRoundDate"
      :currentCompany="currentCompany"
      :workspaceOwner="workspaceOwner"
      context="company-profile"
      :investments="investmentData"
      v-model="dialogMyInvestmentData"
      @save-refresh="getValuationsData"
      @investment-save="refreshInvestments"
      @sendKpiEmail="sendKpiEmail"
    ></DialogAddInvestmentForm>
    <el-dialog
      center
      width="30%"
      title="Export as Pdf"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="modals.pdfInfo"
    >
      <div class="text-center" v-if="isLoading">
        <i class="nc-icon nc-refresh-02 spinner"></i>
        Downloading....
      </div>
      <el-select
        class="todo-dropdown-el-select"
        size="large"
        placeholder="Select type"
        v-model="pdForm"
      >
        <el-option
          v-for="option in pdfValues"
          class="select-primary"
          :value="option"
          :label="option"
          :key="option"
        ></el-option>
      </el-select>
      <input
        type="email"
        v-if="pdForm == 'Send Email'"
        class="form-control"
        v-model="emailId"
        placeholder="Enter Email"
      />
      <button
        type="button"
        class="todo-form-cancel-button btn-outline-secondary"
        @click="modals.pdfInfo = !modals.pdfInfo"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd download"
        style="float: right; margin-right: 0"
        @click="download"
      >
        <i class="fa fa-download" v-if="!isLoading" aria-hidden="true"></i>
        <i v-if="isLoading" class="nc-icon nc-refresh-02 spinner"></i>
        {{ pdForm }}
      </button>
    </el-dialog>
    <editCompany
      ref="editCompanyRef"
      @company-save="companySave"
      v-model="editCompanyModalProps"
      v-if="showEditModalPopup"
    ></editCompany>
    <el-dialog
      center
      width="410px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="!showSpinner"
      :visible.sync="deleteFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this Investment?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteInvestment"
            :disabled="showSpinner"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDeleteInvestment(deleteInvestmentData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showSpinner"
          >
            Delete
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      left
      :title="diligenceTitle"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="550px"
      :visible.sync="noteModel"
      class="noteMdl col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="diligenceNote()">
        <div>
          Notes
          <span v-if="rejectedRequired" class="required">*</span>
          <span v-else>(Optional)</span>
        </div>
        <textarea
          placeholder="Notes"
          :required="rejectedRequired"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="stageNote"
        ></textarea>
        <div class="edit-company-action-button-row py-4" style="margin: 0px">
          <button
            type="button"
            @click="
              noteModel = false;
              isSaving = false;
              diligenceStage = {};
            "
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="isSaving"
          >
            Save
            <b-spinner
              v-if="isSaving"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <DiligencePortfolio
      @save-refresh="diligenceNote"
      v-model="dialogInvest"
    ></DiligencePortfolio>
    <custom-menu></custom-menu>
    <el-dialog
      left
      title="Share Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      style="margin: 0 auto"
      :visible.sync="shareCompanyModalShow"
      @close="
        sharingNote = '';
        tags = [];
        refreshForm = false;
      "
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            v-if="refreshForm"
            :state="state"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            tag-pills
            add-on-change
            :tag-validator="tagValidator"
            @tag-state="onTagState"
            separator=","
          ></b-form-tags>
        </b-form-group>

        <div style="margin-bottom: 8px">
          <div class="flex-row" style="align-items: center">
            <input v-model="showChecklistInShare" type="checkbox" />
            <div style="margin-left: 10px">Include Checklist</div>
          </div>
          <div class="checklist-share-help">
            Only checklist names and description will be shared
          </div>

          <div v-if="showChecklistInShare">
            <div v-for="(checklist, idx) in portfolioChecklist" :key="idx">
              <div class="flex-row" style="align-items: center; margin: 10px">
                <input type="checkbox" v-model="checklist.sendInShare" />
                <div style="margin-left: 10px">{{ checklist.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>Notes</div>
        <textarea
          placeholder="Notes"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="edit-company-action-button-row py-3" style="margin: 0px">
          <button
            type="button"
            @click="hideShareDialog"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            type="button"
            @click.prevent="sendEmail"
            :disabled="emailCheck || SharingCompanySubmit"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Send
            <b-spinner
              v-if="SharingCompanySubmit"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <DialogAddValuationRound
      :organization="currentCompany.organization"
      :contactEmail="contactEmailString"
      :investmentData="rowInvestmentData"
      :lastFundingRoundDate="lastFundingRoundDate"
      :currentCompany="currentCompany"
      context="company-profile"
      :investments="investmentData"
      @investment-save="refreshInvestments"
      @sendKpiEmail="sendKpiEmail"
      @save-refresh="getValuationsData"
      v-model="dialogValuationRound"
    ></DialogAddValuationRound>
    <el-dialog
      center
      width="410px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelDeleteValuation"
      :showClose="!showValuationDeleteSpinner"
      :visible.sync="showDeleteValuationDialog"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this Round?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteValuation"
            :disabled="showValuationDeleteSpinner"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDeleteValuation(deleteValuationData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showValuationDeleteSpinner"
          >
            Delete
            <b-spinner
              v-if="showValuationDeleteSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      width="30%"
      title="Add Checklist"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="isShowAddChecklist"
    >
      <div class="row">
        <div class="col-12">
          <div class="formLabel">Checklist name</div>
          <input
            type="text"
            class="form-control team-form"
            style="width: 100%"
            v-model="newChecklist"
            placeholder="# e.g General"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="formLabel">Copy items from existing</div>
          <el-select
            class="checklist-el-select"
            size="small"
            v-model="newChecklistCopyFromExisting"
          >
            <el-option
              class="select-primary sizingSelect"
              v-for="option in accountChecklist"
              :value="option._id"
              :label="option.name"
              :key="option._id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="col-12 text-right btn-wrapper">
        <button
          type="button"
          class="todo-form-cancel-button btn-outline-secondary"
          @click.prevent="handleCancelChecklistCreate()"
        >
          Cancel
        </button>
        <button
          type="button"
          @click.prevent="handleSaveChecklist()"
          class="todo-form-submit-button btn btn-primary"
          style="height: 35px; margin-left: 15px"
          :disabled="!newChecklist"
        >
          Save
          <b-spinner
            v-if="showSaveChecklistLoader"
            style="float: right"
            small
            label="Loading..."
          ></b-spinner>
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import swal from "sweetalert2";
import Promise from "bluebird";
import util from "util";
import moment from "moment";
import { Company, patchCompany } from "../../../models/Company";
import { mapGetters } from "vuex";
import { Dialog, Select, Option } from "element-ui";
import api from "../../../axios_api";
import {
  CompanyCard,
  LinksCard,
  AddressFormCard,
  BarCompanyComparisonChartCard,
  EditLinksCard,
  TabulatorCard
} from "src/components/index";
import {
  EditableTextAreaCard,
  EditableCompanyCard,
  EditableInvestmentInfoCard,
  ConfirmCard
} from "src/components/index";
import { vals, formatCurrency, formatNumber } from "../../../util";
import {
  ADDRESS_FETCH,
  ADDRESS_UPDATE,
  ADDRESS_CREATE
} from "../../../store/action_types";
import DialogFundingRoundDetails from "../Dialogs/DialogFundingRoundDetails";
import DialogMyInvestmentForm from "../Dialogs/DialogMyInvestmentForm";
import html2pdf from "html2pdf.js";
import twitter from "vue-twitter";
import portfolio from "../../../store/modules/fake/portfolio";
import offering from "../../../store/modules/offering";
import DialogAddInvestmentForm from "../Dialogs/DialogAddInvestmentForm";
import EditCompanyDialog from "../Dialogs/EditCompany";
import DocumentsCard from "../../../components/Cards/DocumentsCard";
import NotesCard from "../../../components/Cards/NotesCard";
import DiligencePortfolio from "../Dialogs/DiligencePortfolio";
import DialogAddValuationRound from "../Dialogs/DialogAddValuationRound";
import CustomMenu from "../Components/CustomMenu.vue";
import config from "../../../../config/settings";
import NewsFeedCard from "../../../components/Cards/NewsFeedCard";
import MrrKpiChart from "../../../components/Cards/DefinedCharts/MrrKpiChart";
import ChurnKpiChart from "../../../components/Cards/DefinedCharts/ChurnKpichart";
import { Radio } from "src/components/index";
import { totalmem } from 'os';
import ChecklistName from "../../../components/ChecklistName.vue";

Vue.use(twitter);

const EMPLOYEE = "employee";
const FOUNDER = "founder";
const ADVISOR = "advisor";
const INVESTOR = "investor";
const DOCUMENT = "document";
const LINKS = "links";
const TEXTAREA = "textarea";
const CONFIRM = "confirm";
const COMPANY = "company";
const NOTES = "notes";
const CONTACTS = "contacts";
const INVESTMENTINFO = "investmentinfo";
const DELETEPROMPT = "deleteprompt";

const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
const DATA_STATUS_CONFIRMED = "Confirmed";

export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    // #region Editable Cards (modals)
    [EditableCompanyCard.name]: EditableCompanyCard,
    [EditableInvestmentInfoCard.name]: EditableInvestmentInfoCard,
    [EditLinksCard.name]: EditLinksCard,
    [EditableTextAreaCard.name]: EditableTextAreaCard,
    // #endregion
    CompanyCard,
    DiligencePortfolio,
    LinksCard,
    AddressFormCard,
    ConfirmCard,
    TabulatorCard,
    [BarCompanyComparisonChartCard.name]: BarCompanyComparisonChartCard,
    [DialogFundingRoundDetails.name]: DialogFundingRoundDetails,
    [DialogMyInvestmentForm.name]: DialogMyInvestmentForm,
    DialogAddInvestmentForm,
    [EditCompanyDialog.name]: EditCompanyDialog,
    [DocumentsCard.name]: DocumentsCard,
    [NotesCard.name]: NotesCard,
    [CustomMenu.name]: CustomMenu,
    [NewsFeedCard.name]: NewsFeedCard,
    DialogAddValuationRound,
    [MrrKpiChart.name]: MrrKpiChart,
    [ChurnKpiChart.name]: ChurnKpiChart,
    [Radio.name]: Radio,
    [ChecklistName.name]: ChecklistName
  },
  computed: {
    getOverallInvestments(){
      let TotalCurrentValue=0, TotalInvestment=0, TotalGain=0, TotalGainPercent=0;
      for(let value of this.investmentData){
        TotalInvestment=TotalInvestment+parseInt(value.amount?value.amount:0)
        TotalCurrentValue= TotalCurrentValue+parseInt(value.currentValue?value.currentValue:0)
      }
      TotalGain=TotalCurrentValue-TotalInvestment;
      TotalGainPercent=TotalCurrentValue/TotalInvestment
      return {
      totalCurrentValue:formatCurrency(
        TotalCurrentValue,
        this.currency.ref
      ),
      totalInvestment:formatCurrency(
        TotalInvestment,
        this.currency.ref
      ),
       totalGain:formatCurrency(
        TotalGain,
        this.currency.ref
      ),
      totalGainPercent:TotalGainPercent?TotalGainPercent.toFixed(2):0
      }
    },

    //...mapGetters("people", ["peopleData"]),
    ...mapGetters("attachment", ["attachmentData"]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("user", ["currency"]),
    ...mapGetters("address", ["getAddress"]),
    ...mapGetters("charts", ["companyRelativeValueByProperty"]),
    ...mapGetters("diligence_stage", ["diligenceStageData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions", "checkRole"]),
    ...mapGetters("charts", ["portfolioTractionData"]),
    ...mapGetters("charts", ["tractionLastUpdatedDate"]),
    currentCompany() {
      return this.$store.getters["temp/currentPortfolioItems"](
        this.$route.params.ucid
      );
    },
    formatNumber() {
      return formatNumber;
    },
    diligenceStageList() {
      let stageData = JSON.parse(JSON.stringify(this.diligenceStageData));
      if (stageData) {
        let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
          item => {
            if (item.toLowerCase() == "ADD INVESTMENT".toLowerCase())
              return item;
          }
        );
        if (featureIndex < 0) {
          stageData = stageData.filter(
            item => item.stage_name.toLowerCase() != "invest"
          );
        }
        return stageData;
      } else return [];
    },
    checkDiligenceStage() {
      let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
        item => {
          if (item.toLowerCase() == "CHANGE DEAL FLOW STAGE".toLowerCase())
            return item;
        }
      );
      if (featureIndex >= 0) return true;
      else return false;
    },
    checkDiligenceRound() {
      let featureIndex = this.getCurrentWorkspaceRolePermissions.findIndex(
        item => {
          if (item.toLowerCase() == "CHANGE DILIGENCE ROUND".toLowerCase())
            return item;
        }
      );
      if (featureIndex >= 0) return true;
      else return false;
    },
    CONSTANTS() {
      return {
        ADVISOR,
        COMPANY,
        CONTACTS,
        DELETEPROMPT,
        DOCUMENT,
        EMPLOYEE,
        FOUNDER,
        LINKS,
        INVESTMENTINFO,
        INVESTOR,
        NOTES
      };
    },
    investments() {
      return this.$store.getters["investment/investmentsByPortfolioId"](
        this.portfolio._id
      );
    },
    companyContacts() {
      return _.cloneDeep(this.currentCompany.contact_email);
    },
    people() {
      const self = this;
      return {
        investors: _.filter(self.peopleData, function(o) {
          return (
            o.context === INVESTOR &&
            o.portfolio_item === self.currentCompany._id
          );
        }),
        employees: _.filter(self.peopleData, function(o) {
          return (
            o.context === EMPLOYEE &&
            o.portfolio_item === self.currentCompany._id
          );
        }),
        advisors: _.filter(self.peopleData, function(o) {
          return (
            o.context === ADVISOR &&
            o.portfolio_item === self.currentCompany._id
          );
        }),
        founders: _.filter(self.peopleData, function(o) {
          return (
            o.context === FOUNDER &&
            o.portfolio_item === self.currentCompany._id
          );
        })
      };
    },
    attachments() {
      const self = this;
      let uploadedDocs = self.$store.getters["file/filesByPortfloioId"](
        this.currentCompany ? this.currentCompany._id : ""
      );
      self.docUpdated++;
      return uploadedDocs;
    },

    address() {
      let address = this.getAddress(this.currentCompany._id);
      return address || {};
    },
    portfolio() {
      let portfolio = _.reduce(
        this.portfolioData,
        (memo, data) => {
          return data.portfolio_item == this.currentCompany._id ? data : memo;
        },
        {}
      );
      return portfolio;
    },
    portfolioOwnership() {
      return (
        (!_.isNil(this.currentCompany.ownership)
          ? this.currentCompany.ownership
          : 0) + "%"
      );
    },
    portfolioMultiple() {
      let num =
        this.currentCompany.value > 0 && this.currentCompany.cost > 0
          ? (this.currentCompany.value / this.currentCompany.cost).toFixed(2)
          : 0;
      return isNaN(num) ? "0" : num;
    },
    portfolioGain() {
      return formatCurrency(
        this.currentCompany.value - this.currentCompany.cost,
        this.currency.ref
      );
    },
    portfolioCost() {
      return formatCurrency(
        this.currentCompany.cost,
        this.currency.ref,
        0,
        false
      );
    },
    portfolioValue() {
      return formatCurrency(
        this.currentCompany.value,
        this.currency.ref,
        0,
        false
      );
    },
    portfolioInitial() {
      // format the date object, need to parse as utc as we don't track time zones
      return moment.utc(this.currentCompany.initial_investment).format("L");
    },
    portfolioLastFunding() {
      // TODO: This needs to be moved into the portfolio data set
      return moment.utc(this.currentCompany.last_funding_round).format("L");
    },
    modalContext() {
      return this.modalInfo.context;
    },
    modalTitle() {
      return "Edit " + this.modalInfo.title;
    },
    modalTitleConfirm() {
      return "Really Delete?";
    },
    valueByProperty() {
      const self = this;
      if (_.isNil(self.currentCompany) || _.isEmpty(self.currentCompany))
        return {};
      let chartData = self.companyRelativeValueByProperty(
        self.currentCompany.name,
        self.chartA.selected
      );
      self.chartA.title = vals.HEADER_MAP[self.chartA.selected];
      // data will have: retval.value: raw value of company, retval.totalValue: value of all companies in its sector/status/etc,
      // retval.value_p: value (in percent) of the company, retval.other: total value of all other companies in sector/status/etc
      let labels = [self.currentCompany.name, "Other"];
      labels = _.map(labels, lbl => {
        return lbl.length < 12
          ? _.padEnd(lbl, 12)
          : lbl.length > 12
          ? _.truncate(lbl, 12)
          : lbl;
      });
      let other_p = Math.round(100 * (1 - chartData.value_p));
      let values = [100 * chartData.value_p, other_p];
      let data = {
        labels,
        datasets: [
          {
            header_label: labels,
            data: values,
            backgroundColor: vals.LEGEND.BACKGROUND_COLORS_1
          }
        ]
      };
      let options = {
        maintainAspectRatio: false,
        legend: {
          position: "top"
        },
        tooltips: {
          mode: "single",
          callbacks: {
            label: function(toolTipItem, data) {
              let perc =
                data.datasets[toolTipItem.datasetIndex].data[toolTipItem.index];
              if (!perc || perc < 1) perc = "< 1";
              if (perc >= 100) perc = "> 99";
              return (
                (data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "") +
                ": " +
                perc +
                "%"
              );
            },
            footer: function(toolTips, data) {
              let toolTipItem = toolTips[0];
              let value =
                data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] === "Other"
                  ? chartData.other
                  : chartData.value;
              value = formatCurrency(value, self.currency.ref, 2);
              return value;
            }
          }
        }
      };
      return { data, options };
    },
    chartOptions() {
      // get all of the non-numerical values
      let retval = { options: [] };
      let row = this.portfolioData[0];
      if (_.isNil(row)) return retval;
      retval.options = _.without(
        _.map(_.keys(row), k => {
          if (vals.PORTFOLIO.GRAPH_OPTIONS.indexOf(k) >= 0)
            return { value: k, label: vals.HEADER_MAP[k] };
          return null;
        }),
        null,
        undefined
      );
      return retval;
    },
    vals() {
      return vals;
    },
    contact_email() {
      return `mailto:${this.currentCompany.contact_email || ""}`;
    },
    contactEmailString() {
      if (
        this.currentCompany.contact_email != "-" &&
        this.currentCompany.contact_email != ""
      ) {
        return this.currentCompany.contact_email;
      } else {
        return "";
      }
    },
    isEditable() {
      return (
        [DATA_STATUS_CONFIRMED].indexOf(this.currentCompany.data_status) != -1
      );
    },
    fundingRounds() {
      let fundingRounds = [];
      let self = this;
      if (this.offerings && this.offerings.length) {
        fundingRounds = this.offerings;
      }
      // format date
      fundingRounds.forEach(item => {
        item.announced_date = moment(item.announced_date); // .format("YYYY-MM-DD");
      });
      return {
        data: fundingRounds,
        options: {
          layout: "fitColumns",
          tooltips: true,
          // pagination: "local",
          // paginationSize: 12,
          // paginationSizeSelector: true,
          tooltipsHeader: true,
          initialSort: [{ column: "gain_loss", dir: "desc" }],
          placeholder: "No records to view",
          rowClick: function(e, row) {
            self.openDialogFundingRound(
              row.getData(),
              row.getPosition(),
              row.getTable().getData()
            );

            e.preventDefault();
            return false;
          }
        },
        columns: this.tableColumns
      };
    },
    tableColumns() {
      const self = this;
      return [
        {
          title: "Status",
          field: "funding_status",
          sorter: "string",
          //width: 80,
          resizable: true
        },
        // {
        //   title: "Verified",
        //   field: "data_status",
        //   sorter: "string",
        //   resizable: true,
        //   //width: "70",
        //   formatter: function (cell, formatterParams) {
        //     switch (cell.getData().data_status) {
        //       case DATA_STATUS_CONFIRMED:
        //         return `
        //           <span  class="success-data-status">
        //             <i class=" nc-icon nc-check-2"></i>
        //           </span>`;
        //         break;
        //       case DATA_STATUS_UNCONFIRMED:
        //         return `
        //           <span  class="warn-data-status">
        //           <i class="nc-icon ">!</i>
        //           </span>`;
        //         break;
        //       case DATA_STATUS_UPDATING:
        //         return `
        //           <span  class="normal-data-status">
        //           <i class="nc-icon nc-refresh-02 spinner "></i>
        //           </span>`;
        //         break;
        //     }
        //     return "-";
        //   },
        // },
        {
          title: "Round",
          field: "funding_type",
          sorter: "string",
          //width: 100,
          resizable: true
        },
        {
          title: "Closing Date",
          field: "announced_date",
          sorter: "date",
          // width: 150,
          resizable: true,
          formatter: function(cell, formatterParams) {
            return moment(cell.getData().announced_date).format("MM/DD/YYYY");
          }
        },
        {
          title: "Total Raised",
          field: "money_raised",
          sorter: "string",
          // width: 150,
          resizable: true
        },
        {
          title: "Investors",
          field: "number_of_investors",
          sorter: "number",
          //width: 150,
          resizable: true
        },
        {
          title: "Lead Investors",
          field: "lead_investors",
          sorter: "string",
          //width: 160,
          resizable: true
        }
        // { title: "Shares", field: "shares", sorter: "string", resizable: true }
      ];
    },
    myInvestments() {
      let self = this;
      let data = JSON.parse(JSON.stringify(self.investmentData));
      data.map(item => {
        item.date = item.date
          ? moment(item.date)
              .utc()
              .format("MM/DD/YYYY")
          : "-";
      });
      return {
        data: data,
        options: {
          layout: "fitColumns",
          tooltips: true,
          // pagination: "local",
          // paginationSize: 12,
          //paginationSizeSelector: true,
          tooltipsHeader: true,
          initialSort: [{ column: "gain_loss", dir: "desc" }],
          placeholder: "No records to view"
          // rowClick: function(e, row) {
          //   self.handleEditInvestment(row.getData());
          //   self.rowInvestmentData = row.getData();
          //   e.preventDefault();
          //   return false;
          // }
        },
        columns: this.investmentTableColumns
      };
    },

    investmentTableColumns() {

      // For custom tooltip display if investment type is safe note
      const tooltip= (type) => `${type}<div
        class="icon"
      >
        <img src="static/img/graphInfo.svg" />
        <div class="customToolTip" >Please click on <i class="fas fa-ellipsis-h" style="color:#fff;margin: 0 3px"></i>  to convert<br /> SAFE Note to Equity</div>
      </div>`
      const self = this;
      var printIcon = function(cell, formatterParams){ //plain text value
      let data = cell.getData();
      return data.investment_type ? (data.investment_type==="SAFE Note"? tooltip(data.investment_type) : data.investment_type) : "Unknown";
      };

      // ===============================================================

      let handleMenu = function(_cell, a, b) {
        let ctxMenuData = [
          {
            title: "Edit",
            handler: () => {
              self.handleEditInvestment(_cell.getData());
              self.rowInvestmentData = _cell.getData();
            }
          },
          {
            title: "Delete",
            handler: () => {
              let data = _cell.getData();
              self.deleteInvestmentData = data;
              self.deleteFlag = true;
            }
          }
        ];

        if (_cell.getData().investment_type === "SAFE Note") {
          ctxMenuData.push({
            title: "Convert to Equity",
            handler: () => {
              self.handleConvertToEquity(_cell.getData());
              self.rowInvestmentData = _cell.getData();
            }
          });
        }
        _cell.getElement().addEventListener("click", () => {
          ctxMenuData, self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-h" style="color:#0000004D;"></i>
        `;
      };

      return [
        {
          title: "Round",
          field: "offering",
          sorter: "string",
          //width: 120,
          resizable: true
        },
        // {
        //   title: "Date",
        //   field: "date",
        //   sorter: "string",
        //   resizable: true
        // },
        {
          title: "Investment",
          field: "amount",
          sorter: "integer",
          //width: 120,
          resizable: true,
          formatter: function(cell, formatterParams) {
            let amount = cell.getData().amount;
            let proceeds_amount = cell.getData().proceeds_amount;
            if (amount) return `$${amount}`;
            else if (proceeds_amount) return `$${proceeds_amount}`;
            else return`-`;
          }
        },
        {
          title: "Value",
          field: "currentValue",
          sorter: "integer",
          //width: 120,
          resizable: true,
          formatter: function(cell, formatterParams) {
            let currentValue = cell.getData().currentValue;
            if (currentValue) return `$${currentValue}`;
            else return`-`;
          }
        },
        {
          title: "Equity Standing",
          sorter: "integer",
          field: "equity_standing.value",
          // width: 180,
          resizable: true,
          formatter: function(cell, formatterParams) {
            let data =
              cell.getData() &&
              cell.getData().equity_standing &&
              cell.getData().equity_standing.value
                ? cell.getData().equity_standing.value
                : "";
            return (data != "" ? Number(Number(data).toFixed(1)) : "") + "%";
          }
        },
        {
          title: "No. Of Shares",
          field: "no_of_shares",
          // width: 100,
          sorter: "string",
          resizable: true,
          formatter: function(cell, formatterParams) {
            let data = cell.getData();
            //  return moment(cell.getData().investment_date).format("MM/DD/YYYY");
            return data.no_of_shares ? data.no_of_shares : "-";
          }
        },
        // {
        //   title: "Share Price",
        //   field: "price_per_share",
        //   // width: 100,
        //   sorter: "string",
        //   resizable: true,
        //   formatter: function(cell, formatterParams) {
        //     let data = cell.getData();
        //     //  return moment(cell.getData().investment_date).format("MM/DD/YYYY");
        //     return data.price_per_share ? data.price_per_share : "-";
        //   }
        // },
        {
          title: "Type",
          field: "investment_type",
          // width: 100,
          sorter: "string",
          resizable: true,
          
          formatter: printIcon
        },
        {
          title: "",
          field: "",
          sorter: "string",
          width: 20,
          headerSort: false,
          resizable: false,
          //formatter: handleMenu,
          formatter: function(_cell, formatterParams) {
            if (self.showInvestmentDelete && self.showInvestmentAdd) {
              if (_cell.getData()) {
                return handleMenu(_cell, formatterParams, formatterParams);
              } else {
                return "";
              }
            } else {
              return "";
            }
          }
        }
      ];
    },
    offeringFundPhase() {
      if (this.offerings.length) {
        let totalFunds = 0;
        this.offerings.map(item => {
          if (!isNaN(item.money_raised_in_numbers))
            totalFunds = totalFunds + item.money_raised_in_numbers;
        });
        let offeringArray = JSON.parse(JSON.stringify(this.offerings));
        offeringArray.sort((a, b) => {
          return new Date(a.announced_date) - new Date(b.announced_date);
        });
        // let latest = this.offerings[this.offerings.length - 1];
        let latest = offeringArray[offeringArray.length - 1];
        this.lastFundingRoundDate = moment(latest.announced_date).format(
          "MMM DD, YYYY"
        );
        return `${this.currentCompany.name} has raised a total of $${
          totalFunds ? formatNumber(totalFunds) : 0
        } in funding over ${this.offerings.length} ${
          this.offerings.length == 1 ? "round" : "rounds"
        }. Their latest funding was raised on ${moment(
          latest.announced_date
        ).format("MMM DD, YYYY")} from a  ${latest.funding_type} round.`;
      }
      return `${this.currentCompany.name}  has no offering yet.`;
    },
    myInvestmentPhrase() {
      if (this.investmentData.length) {
        let totalInvestment = 0;
        this.investmentData.map(item => {
          if (item.amount.length > 0)
            totalInvestment = totalInvestment + parseInt(item.amount);
        });
        let invstArray = JSON.parse(JSON.stringify(this.investmentData));
        invstArray.sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
        let latest = invstArray[invstArray.length - 1];
        let latestInvestmentDate = latest.date
          ? `was on ${moment(latest.date).format("MMM DD, YYYY")}`
          : "";
        return `You have invested $${
          totalInvestment ? formatNumber(totalInvestment) : 0
        } across ${this.investmentData.length} ${
          this.investmentData.length == 1 ? "round" : "rounds"
        } in ${
          this.currentCompany.name //$  {latest.offering.funding_type}
        }. Your latest investment ${latestInvestmentDate} in ${latest.offering}
         round.`;
      }

      return "You have not invested in this company yet.";
    },
    downloadProps() {
      if (!this.currentCompany) {
        return;
      }

      let myInvestments = this.myInvestments;
      for (let investment of myInvestments.data) {
        investment.investment_date = moment
          .utc(investment.investment_date)
          .format("MM/DD/YYYY");
        investment.funding_round = investment.offering;
      }
      let fundingRounds = this.fundingRounds;
      for (let fundingRound of fundingRounds.data) {
        fundingRound.close_date = moment
          .utc(fundingRound.announced_date)
          .format("MM/DD/YYYY");
      }
      //let portfolioDetails = this.portfolio;
      let portfolioDetails = this.currentCompany || {};
      portfolioDetails.initial_investment =
        portfolioDetails.initial_investment &&
        portfolioDetails.initial_investment.length > 7
          ? moment.utc(portfolioDetails.initial_investment).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.last_funding_round =
        portfolioDetails.last_funding_round &&
        portfolioDetails.last_funding_round.length > 7
          ? moment.utc(portfolioDetails.last_funding_round).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.founding_date =
        portfolioDetails.founding_date &&
        portfolioDetails.founding_date != "Invalid date"
          ? portfolioDetails.founding_date
          : "-";
      if (portfolioDetails.founding_date == "Invalid date") {
        portfolioDetails.founding_date = "-";
      }
      //console.log("portfolioDetails", portfolioDetails.founding_date);
      portfolioDetails.last_funding_type = portfolioDetails.last_funding_type
        ? portfolioDetails.last_funding_type
        : "-";
      // this.offerings && this.offerings[0] && this.offerings[0].funding_type
      //   ? this.offerings[0].funding_type
      //   : "";
      let companyNamePdf = this.currentCompany.name.split(" ").join("_");
      let currentTime = new Date()
        .toLocaleString()
        .split(", ")
        .join("_");
      portfolioDetails.stage_i_invested = this.currentCompany.stage_i_invested;
      const payload = {
        portfolio: {
          portfolioOwnership: this.portfolioOwnership,
          portfolioCost: this.portfolioCost,
          portfolioValue: this.portfolioValue,
          portfolioMultiple: this.portfolioMultiple,
          portfolioGain: this.portfolioGain,
          contact_email: this.contact_email,
          companyContacts: this.companyContacts
        },
        pdfType: this.pdForm,
        recieverEmail: this.emailId,
        currentCompany: this.currentCompany,
        myInvestments,
        fundingRounds,
        attachments: this.attachments,
        fileName: `${companyNamePdf}_${currentTime}.pdf`,
        notes: this.notes,
        people: this.people,
        portfolioDetails
      };
      return payload;
    },
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    myValuations() {
      let self = this;
      let valuationData = self.$store.getters["rounds/roundsByPortfolioId"](
        self.currentCompany._id
      );
      let data = JSON.parse(JSON.stringify(valuationData));
      this.raisedToDate = 0;
      data.map(item => {
        item.date = item.date ? moment(item.date).format("MM/DD/YYYY") : "-";
        if (item.roundSize && Number(item.roundSize)) {
          this.raisedToDate += Number(item.roundSize);
        }
      });
      return {
        data: data,
        options: {
          layout: "fitColumns",
          tooltips: true,
          // pagination: "local",
          index: "_id",
          tooltipsHeader: true,
          initialSort: [{ column: "date", dir: "asc" }],
          placeholder: "No records to view",
          rowFormatter: function(row) {
            let data = row._row.data;
            if (data.isParticipated) {
              row.getElement().classList.add("notParticipated");
            }
          }
        },
        columns: this.valuationTableColumns
      };
    },
    valuationTableColumns() {
      const self = this;
      let handleMenu = function(_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                self.handleEditValuation(_cell.getData());
              }
            },
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
                self.deleteValuationData = data;
                self.showDeleteValuationDialog = true;
              }
            }
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-h" style="color:#0000004D;"></i>
        `;
      };

      return [
        {
          title: "Round",
          field: "offering",
          sorter: "string",
          resizable: true
        },
        {
          title: "Date",
          field: "date",
          sorter: "string",
          resizable: true
        },
        {
          title: "pre $",
          field: "preMoney",
          sorter: "integer",
          resizable: true,
          formatter: function(cell, formatterParams) {
            return cell.getData().preMoney
              ? formatCurrency(
                  cell.getData().preMoney,
                  self.currency.ref,
                  0,
                  true
                )
              : 0;
          }
        },
        {
          title: "Round size",
          field: "roundSize",
          sorter: "integer",
          resizable: true,
          formatter: function(cell, formatterParams) {
            return cell.getData().roundSize
              ? formatCurrency(
                  cell.getData().roundSize,
                  self.currency.ref,
                  0,
                  true
                )
              : 0;
          }
        },
        {
          title: "post $",
          field: "postMoney",
          sorter: "integer",
          resizable: true,
          formatter: function(cell, formatterParams) {
            return cell.getData().postMoney
              ? formatCurrency(
                  cell.getData().postMoney,
                  self.currency.ref,
                  0,
                  true
                )
              : 0;
          }
        },
        {
          title: "PPS",
          field: "pricePerShare",
          sorter: "string",
          sorter: "integer",
          resizable: true,
          formatter: function(cell, formatterParams) {
            return cell.getData().pricePerShare
              ? formatCurrency(
                  cell.getData().pricePerShare,
                  self.currency.ref,
                  0,
                  true
                )
              : 0;
          }
        },
        {
          title: "Verified",
          field: "isVerified",
          resizable: true,
          tooltip: false,
          formatter: function(cell, formatterParams) {
            let data = cell.getData();
            if (data.isVerified) {
              return `<img src="static/img/verifiedCircleWithTick.svg" class=""/>`;
            }
            return `<img src="static/img/notVerifiedCircle.svg" class=""/>`;
          }
        },
        {
          title: "",
          field: "",
          sorter: "string",
          width: 20,
          headerSort: false,
          resizable: false,
          //formatter: handleMenu,
          formatter: function(_cell, formatterParams) {
            if (self.showRoundsDelete && self.showRoundsAdd) {
              if (_cell.getData()) {
                return handleMenu(_cell, formatterParams, formatterParams);
              } else {
                return "";
              }
            } else {
              return "";
            }
          }
        }
      ];
    },
    moment() {
      return moment;
    },
    valuationRaiseToData() {
      return this.raisedToDate && this.raisedToDate > 0
        ? this.formatCurrency(this.raisedToDate, this.currency.ref, 0, true)
        : "$0";
    },
    showInvestmentAdd() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex(item => {
        if (item == "ADD INVESTMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showInvestmentDelete() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex(item => {
        if (item == "DELETE INVESTMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showRoundsAdd() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex(item => {
        if (item == "ADD ROUND") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showRoundsDelete() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex(item => {
        if (item == "DELETE ROUND") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    }
  },
  data() {
    return {
      workspaceOwner: "",
      deleteChecklist: false,
      deleteChecklistObject: null,
      rou: "",
      pageTitle: "Company profile", //to check in diligence portfolio component
      noteModel: false,
      stageNote: "",
      isSaving: false,
      referralsData: {},
      lastFundingRoundDate: "",
      investmentData: [],
      currentValue:0,
      rowInvestmentData: {},
      peopleData: [],
      offerings: [],
      editRoute: "",
      isLoading: false,
      emailId: "",
      lefttable: "col-md-4",
      righttable: "col-md-8",
      DATA_STATUS_UNCONFIRMED,
      DATA_STATUS_UPDATING,
      DATA_STATUS_CONFIRMED,
      chartA: { selected: "sector", title: "Sector" },
      edit: {},
      links: [], // structure for handing data to the edit-links-card
      modals: {
        links: false,
        textarea: false,
        company: false,
        confirm: false,
        investmentinfo: false,
        crunchBaseInfo: {},
        pdfInfo: false
      },
      dialogInvest: {
        isShow: false,
        data: {},
        isCreate: true
      },
      pdForm: "Download as Pdf",
      modalInfo: {
        key: 0, // used to force re-rendering
        title: "",
        context: {}
      },
      notes: "",
      textArea: "",
      updateDisplay: 0,
      docUpdated: 0,
      dialogFundingRoundData: {
        isShow: false,
        data: {},
        currentIndex: 0,
        fullData: []
      },
      dialogMyInvestmentData: {
        isShow: false,
        data: {},
        isCreate: true
      },
      newsFeedList: [],
      crunchBaseInfo: {},
      pdfValues: ["Download as Pdf", "Send Email"],
      showEditModalPopup: false,
      editCompanyModalProps: {},
      deleteFlag: false,
      deleteInvestmentData: {},
      showSpinner: false,
      diligenceStage: {},
      diligenceTitle: "",
      rejectedRequired: false,
      editInvestmentData: {},
      investmentTabulator: null,
      shareCompanyModalShow: false,
      refreshForm: false,
      sharingNote: "",
      tags: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      SharingCompanySubmit: false,
      valuationTabulator: null,
      valuationData: [],
      valuationDialogTitle: "",
      valuationDialogShow: false,
      valuationDialogData: {},
      showValuationSpinner: false,
      raisedToDate: 0,
      showValuationDeleteSpinner: false,
      deleteValuationData: {},
      showDeleteValuationDialog: false,
      dialogValuationRound: {
        isCreate: false,
        data: {},
        isShow: false,
        portfolio_item: "",
        previous_round: {}
      },
      refreshNotes: true,
      refreshDocuments: true,

      portfolioChecklist: [],
      accountChecklist: [],
      isShowAddChecklist: false,
      newChecklist: "",
      newChecklistCopyFromExisting: "",
      showSaveChecklistLoader: false,
      showSaveCheck: false,
      currentItemId: null,
      showChecklistInShare: false,
      editName: false,
    };
  },
  methods: {
     getAllChecklist(){
      this.$store.dispatch("checklist/apiFetchAllChecklist").then(res=>{
        this.accountChecklist = res;
      })
    },
    toggleEditChecklistName(){
      this.editName = !this.editName;
    },
    deleteChecklistModal(data) {
      this.deleteChecklist = true;
      this.deleteChecklistObject = null;

      this.deleteChecklistObject = data;
    },
    handleCancelDeleteChecklist() {
      // this.deleteData = {};
      this.deleteChecklist = false;
    },
    handleDeleteChecklist() {
      let self = this;

      self.showDeleteChecklistItemSpinner = true;
      api
        .delete(
          `/${self.$route.params.account_id}/${this.deleteChecklistObject.workspace}/${this.deleteChecklistObject.portfolio_item}/checklist/${this.deleteChecklistObject._id}`
          // {
          //   encrypt: {
          //     data: {
          //       is_done: item.is_done,
          //       summary: item.summary
          //     }
          //   }
          // }
        )
        .then(res => {
          self.$store
            .dispatch(
              "checklist/apiDeleteChecklist",
              self.deleteChecklistObject._id
            )
            .then(data => {
              self.getChecklistItems();
              self.getAllChecklist();
              self.deleteChecklist = false;
            })
            .catch(error => {
              self.$toaster.error("Failed to delete round !!!");
            });
        })
        .catch(error => {
          this.$toaster.error("Failed to Delete Todo..!!");
        });
    },
    companySave() {},
    removeTag(tag, index) {
      let self = this;

      let tags = JSON.parse(JSON.stringify(this.currentCompany.tags));
      tags.splice(index, 1);
      let serverData = JSON.parse(JSON.stringify(this.currentCompany));
      serverData.last_funding_round =
        serverData.last_funding_round &&
        serverData.last_funding_round != "-" &&
        serverData.last_funding_round != "Invalid date"
          ? serverData.last_funding_round
          : "";
      serverData.initial_investment =
        serverData.initial_investment &&
        serverData.initial_investment != "-" &&
        serverData.initial_investment != "Invalid date"
          ? serverData.initial_investment
          : "";

      serverData.tags = tags;
      let company = patchCompany(serverData._id);
      if (company.update(serverData)) {
        return company
          .writeToServer()
          .then(() => {
            self.$store.dispatch("portfolio/_apiFetchPortfolio");
            this.$toaster.success("Tag Removed Successfully");
          })
          .catch(error => {
            console.log("edit company error", error);
            this.$toaster.error("Failed to remove company");
          });
      }
    },
    changeDealRound(e) {
      let self = this;
      let payload = {};
      payload.stage = e;
      payload._id = self.currentCompany.diligenceId;
      payload.portfolio_item = self.currentCompany._id;
      payload.ucid = self.currentCompany.ucid;
      payload.organization = self.currentCompany.organization;
      payload.name = self.currentCompany.name;
      self.$store
        .dispatch("diligence/apiPatchDiligenceInst", payload)
        .then(data => {
          self.sendDiligenceNotifications("round", payload);
        })
        .catch(err => {
          console.log({ err });
        });
    },
    sendDiligenceNotifications(type, diligenceData) {
      if (this.checkRole && this.checkRole.toLowerCase() == "collaborator") {
        diligenceData.account_id = this.$route.params.account_id;
        diligenceData.workspace_id = this.$route.params.workspace_id;
        this.$store.dispatch("notifications/apiDiligenceCollaboratorReceipt", {
          type,
          diligenceData
        });
      }
    },
    noteModalShow(e) {
      let self = this;
      this.stageNote = "";
      let payload = this.diligenceStageList.filter(item => item._id == e);
      if (payload.length > 0) {
        this.diligenceStage = payload[0];
        if (payload[0].stage_name == "Invest") {
          this.diligenceTitle = "Investment";
          let payload = {};
          payload.initial_investment = new Date();
          payload._id = self.currentCompany.diligenceId;
          payload.portfolio_item = self.currentCompany._id;
          payload.name = self.currentCompany.name;
          payload.ucid = self.currentCompany.ucid;
          payload.stage = self.currentCompany.stage;
          self.dialogInvest = {
            data: {
              portfolio: payload
            },
            isShow: true
          };
        } else if (payload[0].stage_name == "Pass") {
          this.diligenceTitle = "Why Pass?";
          this.noteModel = true;
          this.rejectedRequired = true;
          this.isSaving = false;
        } else {
          this.diligenceTitle = "Add Note";
          this.noteModel = true;
          this.isSaving = false;
          this.rejectedRequired = false;
        }
      } else this.$toaster.error("Failed to update the Diligence.");
    },
    diligenceNote() {
      let self = this;
      let payload = {},
        url = "";
      let notificationPayload = {
        ucid: self.currentCompany.ucid,
        organization: self.currentCompany.organization,
        name: self.currentCompany.name
      };
      if (this.diligenceTitle == "Add Note") {
        self.isSaving = true;
        payload.note = self.stageNote;
        payload._id = self.currentCompany.diligenceId;
        payload.stageId = self.diligenceStage._id;
        payload.color = self.diligenceStage.color;
        payload.portfolio_item = self.currentCompany._id;
        notificationPayload.stage = self.diligenceStage.stage_name;
        url = "diligence/apiPatchDiligenceStageInst";
      } else if (this.diligenceTitle == "Investment") {
        payload.passedNotes = "Invested";
        payload.deal_stage = self.diligenceStage._id;
        payload._id = self.currentCompany.diligenceId;
        url = "diligence/apiStatusUpdate";
      } else if (this.diligenceTitle == "Why Pass?") {
        payload.rejectedNotes = self.stageNote;
        payload.deal_stage = self.diligenceStage._id;
        payload._id = self.currentCompany.diligenceId;
        url = "diligence/apiStatusUpdate";
        notificationPayload.stage = "rejected";
      }
      self.$store
        .dispatch(url, payload)
        .then(data => {
          self.noteModel = false;
          self.isSaving = false;
          self.sendDiligenceNotifications("stage", notificationPayload);
          if (self.diligenceTitle == "Why Pass?")
            self.$store.dispatch("referrer/start");
          self.$refs.noteRef.getNotes();
        })
        .catch(err => {
          self.isSaving = false;
          self.$toaster.error("Fail to update the stage.");
        });
    },
    download() {
      this.modals.pdfInfo = true;
      let myInvestments = this.myInvestments;
      for (let investment of myInvestments.data) {
        investment.investment_date = moment
          .utc(investment.investment_date)
          .format("MM/DD/YYYY");
      }
      let fundingRounds = this.fundingRounds;
      for (let fundingRound of fundingRounds.data) {
        fundingRound.close_date = moment
          .utc(fundingRound.announced_date)
          .format("MM/DD/YYYY");
      }
      let portfolioDetails = this.currentCompany;
      portfolioDetails.initial_investment =
        portfolioDetails.initial_investment &&
        portfolioDetails.initial_investment.length > 7
          ? moment.utc(portfolioDetails.initial_investment).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.last_funding_round =
        portfolioDetails.last_funding_round &&
        portfolioDetails.last_funding_round.length > 7
          ? moment.utc(portfolioDetails.last_funding_round).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.founding_date = moment
        .utc(portfolioDetails.founding_date)
        .format("MM/DD/YYYY");
      portfolioDetails.last_funding_type = "Series A";
      // this.offerings && this.offerings[0] && this.offerings[0].funding_type
      //   ? this.offerings[0].funding_type
      //   : "";
      let companyNamePdf = this.currentCompany.name.split(" ").join("_");
      let currentTime = new Date()
        .toLocaleString()
        .split(", ")
        .join("_");
      portfolioDetails.stage_i_invested = this.currentCompany.stage_i_invested;
      const payload = {
        portfolio: {
          portfolioOwnership: this.portfolioOwnership,
          portfolioCost: this.portfolioCost,
          portfolioValue: this.portfolioValue,
          portfolioMultiple: this.portfolioMultiple,
          portfolioGain: this.portfolioGain,
          contact_email: this.contact_email,
          companyContacts: this.companyContacts
        },
        pdfType: this.pdForm,
        recieverEmail: this.emailId,
        currentCompany: this.currentCompany,
        myInvestments,
        fundingRounds,
        attachments: this.attachments,
        fileName: `${companyNamePdf}_${currentTime}.pdf`,
        notes: this.notes,
        people: this.people,
        portfolioDetails
      };
      this.isLoading = true;
      api
        .post("/file/uploadEmail", { encrypt: { data: payload } })
        .then(res => {
          this.isLoading = false;
          if (this.pdForm != "Send Email") {
            return window.open(res.data.encrypt.success);
          }
          this.modals.pdfInfo = false;
        });
    },
    closeModal(ctx, eventData) {
      const self = this;
      if (!_.isNil(ctx)) {
        if (ctx.name != DELETEPROMPT) {
          self.modals[ctx.name] = false;
        }
        switch (ctx.name) {
          case EMPLOYEE:
          case FOUNDER:
          case ADVISOR:
          case INVESTOR:
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              // set all links context correctly, remove 'id'
              let data = eventData.data;
              let people = { updated: [], added: [], deleted: [] };
              people.added = _.map(data.added, e => {
                if (_.isNil(e.name) || _.isEmpty(e.name)) return null;
                e.context = ctx.name;
                e.company = self.currentCompany._id;
                delete e.id;
                return e;
              });
              people.added = _.without(people.added, null, undefined);
              people.updated = data.updated || [];
              people.deleted = data.deleted || [];
              // merge with our caches
              if (!_.isNil(people.added) && !_.isEmpty(people.added))
                self.$store.commit("people/update_add", people.added);
              if (!_.isNil(people.deleted) && !_.isEmpty(people.deleted))
                self.$store.commit("people/update_delete", people.deleted);
              if (!_.isNil(people.updated) && !_.isEmpty(people.updated))
                self.$store.commit("people/update_update", people.updated);
              // self.modalInfo.key += 1; // forces re-render of the edit-links component
            }
            // these all use the name 'LINKS' for the modal name
            ctx.name = LINKS;
            self.modals[ctx.name] = false;
            break;
          case CONTACTS:
            // these all use the name 'LINKS' for the modal name
            ctx.name = NOTES;
            self.modals[ctx.name] = false;
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              // save the contact info
              let data = eventData.data;
              let company = patchCompany(self.currentCompany._id);
              let obj = { contacts: data };
              if (company.update(obj)) {
                // save to server
                return company
                  .writeToServer()
                  .then(res => {
                    // merge info saved
                    self.$store.commit("company/merge", {
                      companies: [company]
                    });
                    self.updateDisplay++;
                  })
                  .catch(err => {
                    // display error (prob from server)
                    let text = !_.isNil(err.error) ? err.error : "Unkonwn";
                    swal({
                      title: `Unable to Save Company Info`,
                      buttonsStyling: false,
                      confirmButtonClass: `btn btn-danger btn-fill`,
                      text
                    });
                  });
              }
            }
            break;
          case DOCUMENT:
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              // set all links context correctly, remove 'id'
              let data = eventData.data;
              let attachment = { updated: [], added: [], deleted: [] };
              attachment.added = _.map(data.added, e => {
                if (_.isNil(e.name) || _.isEmpty(e.name)) return null;
                e.context = "document";
                e.company = self.currentCompany._id;
                delete e.id;
                return e;
              });
              attachment.added = _.without(attachment.added, null, undefined);
              attachment.updated = data.updated || [];
              attachment.deleted = data.deleted || [];
              // merge with our caches
              if (!_.isNil(attachment.added) && !_.isEmpty(attachment.added))
                self.$store.commit("attachment/update_add", attachment.added);
              if (
                !_.isNil(attachment.deleted) &&
                !_.isEmpty(attachment.deleted)
              )
                self.$store.commit(
                  "attachment/update_delete",
                  attachment.deleted
                );
              if (
                !_.isNil(attachment.updated) &&
                !_.isEmpty(attachment.updated)
              )
                self.$store.commit(
                  "attachment/update_update",
                  attachment.updated
                );
            }
            // these all use the name 'LINKS' for the modal name
            ctx.name = LINKS;
            self.modals[ctx.name] = false;
            break;
          case DELETEPROMPT:
            if (!_.isNil(eventData) && eventData.confirm) {
              // delete the company and related data
              self.deleteCompany();
            } else {
              self.modals[ctx.name] = false;
              self.updateDisplay++;
            }
            break;
          case TEXTAREA:
            break;
          case CONFIRM:
            break;
          case COMPANY:
            // update a company object and save it
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              self.updateCompany(eventData.data);
            } else {
              self.updateDisplay++;
            }
            break;
          case NOTES:
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              // save it, as company notes
              self.$store.commit("portfolio/update", {
                name: self.currentCompany.name,
                notes: _.cloneDeep(eventData.data)
              });
              self.notes = _.cloneDeep(eventData.data);
            }
            break;
          case INVESTMENTINFO:
            if (
              !_.isNil(eventData) &&
              eventData.confirm &&
              !_.isNil(eventData.data)
            ) {
              let last_funding = _.cloneDeep(eventData.data.last_funding);
              //save the changes made...
              self.$store.commit("portfolio/update", eventData.data);
              // TODO: Need to move the concept of 'last funding round' to portfolio data
              self.updateCompany({ last_funding }); // update the company object with the new last_funding_round entered
            }
            break;
          default:
            console.error(`Unkonwn context: ${JSON.stringify(ctx)}`);
        }

        if (ctx.name != DELETEPROMPT) {
          self.updateDisplay++;
        }
      }
    },
    openModal(ctx) {
      const self = this;
      // determine which modal is being open and set the options as needed
      if (!_.isNil(ctx)) {
        switch (ctx.name) {
          case EMPLOYEE:
          case FOUNDER:
          case ADVISOR:
          case INVESTOR:
            // all of these have a similar logic path
            self.modalInfo.title = _.capitalize(ctx.name);
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            // these all use the name 'LINKS' for the modal name (and edit info)
            ctx.name = LINKS;
            // setup our data to edit
            self.links = _.filter(self.peopleData, function(o) {
              return (
                o.context === self.modalInfo.context.name &&
                o.company == self.currentCompany._id
              );
            });
            self.modalInfo.key++; // forces re-render of the edit-links component
            break;
          case CONTACTS:
            self.modalInfo.title = _.capitalize(ctx.name);
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            self.textArea = _.cloneDeep(self.currentCompany.contacts);
            // these all use the name 'LINKS' for the modal name
            ctx.name = NOTES;
            self.modalInfo.key++;
            break;
          case DOCUMENT:
            // similar but different
            self.modalInfo.title = _.capitalize(ctx.name);
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            // these all use the name 'LINKS' for the modal name
            ctx.name = LINKS;
            self.links = _.filter(self.attachmentData, function(o) {
              return (
                o.context === self.modalInfo.context.name &&
                o.company == self.currentCompany._id
              );
            });
            self.modalInfo.key++;
            break;
          case DELETEPROMPT:
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            break;
          case TEXTAREA:
            break;
          case CONFIRM:
            break;
          case COMPANY:
            self.modalInfo.title = _.capitalize(COMPANY);
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            self.edit[ctx.name] = _.cloneDeep(self.currentCompany);
            break;
          case NOTES:
            self.modalInfo.title = _.capitalize(NOTES);
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            self.textArea = _.cloneDeep(self.notes);
            break;
          case INVESTMENTINFO:
            self.modalInfo.title = "Investment Info";
            // set our context for the callback
            self.modalInfo.context = { name: ctx.name };
            self.edit[ctx.name] = _.cloneDeep(self.portfolio);
            // TODO: Need to move the concept of 'last funding round' to portfolio data
            self.edit[ctx.name].last_funding = _.cloneDeep(
              self.portfolio.last_funding_round
            );
            break;
          default:
            console.error(`Unknown context ${JSON.stringify(ctx)}`);
        }
        // open the correct modal
        self.modals[ctx.name] = true;
      }
    },
    updateCompany(data) {
      // do an update
      let company = patchCompany(this.currentCompany._id);
      if (company.update(data)) {
        // update successful, skip validation - as we may not have everything filled out for an update
        return company
          .writeToServer()
          .then(() => {
            // merge the company info just saved
            this.$store.commit("company/merge", {
              companies: [company]
            });
            // this.updateDisplay++;
          })
          .catch(err => {
            // if (errors is array & non-zero, display validation errors)
            if (
              !_.isNil(err.errors) &&
              _.isArray(err.errors) &&
              !_.isEmpty(err.errors)
            ) {
              // display validation errors
              let html = `<p>There were validation errors with your ${err.type} information</p>`;
              _.each(err.errors, e => {
                html += `${e}<br />`;
              });
              html += `</p>`;
              swal({
                title: `${_.startCase(err.type)} Validation Errors`,
                buttonsStyling: false,
                confirmButtonClass: `btn btn-danger btn-fill`,
                html
              });
            } else {
              // display error (prob from server)
              let text = !_.isNil(err.error) ? err.error : "Unkonwn";
              swal({
                title: `Unable to Save Company Info`,
                buttonsStyling: false,
                confirmButtonClass: `btn btn-danger btn-fill`,
                text
              });
            }
            // reset our edit info and update display
            // this.updateDisplay++;
          });
      }
    },
    updateAddress(e) {
      // update/create the company's address
      let address = this.getAddress(this.currentCompany._id) || {};
      if (!_.isNil(e) && !_.isNil(e.address)) {
        address = _.assign(address, e.address);
        address.parent = this.currentCompany._id;
        if (!_.isNil(address._id)) {
          this.$store
            .dispatch(`address/${ADDRESS_UPDATE}`, _.assign(address, e.address))
            .then(res => {})
            .catch(err => {});
        } else {
          this.$store
            .dispatch(`address/${ADDRESS_CREATE}`, _.assign(address, e.address))
            .then(res => {})
            .catch(err => {});
        }
      }
    },
    openDialogFundingRound(data, idx, fullData) {
      this.dialogFundingRoundData = {
        isShow: true,
        data: data,
        currentIndex: idx,
        fullData: fullData
      };
    },
    handleCreateInvestment() {
      let previous_round;
      if (this.valuationData && this.valuationData.length > 0) {
        previous_round = this.valuationData[this.valuationData.length - 1];
      }
      this.dialogMyInvestmentData = {
        isShow: true,
        isCreate: true,
        isEdit: false,
        isConvertToEquity: false,
        data: {
          isParticipated: false,
          isVerified: false,
          date: moment(new Date()),
          company_name: this.currentCompany.name,
          portfolio_item: this.currentCompany._id,
          workspace: this.currentCompany.workspace,
          investment_type: "SAFE Note",
          transaction_date: new Date(),
          currentValue: ''
        },
        portfolio_item:
          this.currentCompany && this.currentCompany._id
            ? this.currentCompany._id
            : "",
        previous_round: previous_round ? previous_round : null,
        currentCompany: this.currentCompany
      };
    },
    handleEditInvestment(data) {
      let self = this;
      self.editInvestmentData = data;
      let refer = [];
      if (data.refer) {
        data.refer.map(item => {
          refer.push({ key: item.attributor, value: item.name });
        });
      }
      let notes = self.$refs.noteRef.notesData.filter(
        item => item.entity == "Investment" && item.entity_id == data._id
      );

      this.dialogMyInvestmentData = {
        isShow: true,
        isCreate: false,
        isEdit: true,
        isConvertToEquity: false,
        data: {
          _id: data._id,
          offering: data.offering,
          transaction_date: data.date || "",
          amount: data.amount,
          equity: data.equity,
          equity_standing:
            data && data.equity_standing && data.equity_standing.value
              ? data.equity_standing.value
              : "",
          cohort: data.cohort,
          term: data.term,
          investment_type: data.direct,
          referred_by: refer,
          investment_type: data.investment_type
            ? data.investment_type
            : "Unknown",
          cap: data.cap ? data.cap : "",
          discount: data.discount ? data.discount : "",
          excerise_price: data.excerise_price ? data.excerise_price : "",
          price_per_share: data.price_per_share ? data.price_per_share : "",
          investment_proceeds_type: data.investment_proceeds_type
            ? data.investment_proceeds_type
            : "",
          term_years: data.term_years ? data.term_years : "",
          no_of_shares: data.no_of_shares ? data.no_of_shares : "",
          coverage: data.coverage ? data.coverage : "",
          interest_rate: data.interest_rate ? data.interest_rate : "",
          interest: data.interest ? data.interest : "",
          maturity_date: data.maturity_date ? data.maturity_date : "",
          due_date: data.due_date ? data.due_date : "",
          security: data.security ? data.security : "",
          notes: notes.length > 0 ? notes[0].description : "",
          noteId: notes.length > 0 ? notes[0]._id : "",
          tags: data.tags ? data.tags : [],
          is_prorata: data.is_prorata,
          is_lead_investor: data.is_lead_investor,
          board_seat: data.board_seat,
          information_rights: data.information_rights,
          portfolio_item: this.currentCompany._id,
          workspace: this.currentCompany.workspace,
          currentValue: data.currentValue?data.currentValue:'',
          proceeds_amount: data.proceeds_amount
        }
      };
    },
    handleConvertToEquity(data) {
      let self = this;
      self.editInvestmentData = data;
      let refer = [];
      if (data.refer) {
        data.refer.map(item => {
          refer.push({ key: item.attributor, value: item.name });
        });
      }
      let notes = self.$refs.noteRef.notesData.filter(
        item => item.entity == "Investment" && item.entity_id == data._id
      );

      this.dialogMyInvestmentData = {
        isShow: true,
        isCreate: false,
        isEdit: false,
        isConvertToEquity: true,
        data: {
          _id: data._id,
          offering: data.offering,
          transaction_date: data.date || "",
          amount: data.amount,
          equity: data.equity,
          equity_standing:
            data && data.equity_standing && data.equity_standing.value
              ? data.equity_standing.value
              : "",
          cohort: data.cohort,
          term: data.term,
          investment_type: "Equity",
          referred_by: refer,
          // investment_type: data.investment_type
          //   ? data.investment_type
          //   : "Unknown",
          cap: data.cap ? data.cap : "",
          discount: data.discount ? data.discount : "",
          excerise_price: data.excerise_price ? data.excerise_price : "",
          price_per_share: data.price_per_share ? data.price_per_share : "",
          investment_proceeds_type: data.investment_proceeds_type
            ? data.investment_proceeds_type
            : "",
          term_years: data.term_years ? data.term_years : "",
          no_of_shares: data.no_of_shares ? data.no_of_shares : "",
          coverage: data.coverage ? data.coverage : "",
          interest_rate: data.interest_rate ? data.interest_rate : "",
          interest: data.interest ? data.interest : "",
          maturity_date: data.maturity_date ? data.maturity_date : "",
          due_date: data.due_date ? data.due_date : "",
          security: data.security ? data.security : "",
          notes: notes.length > 0 ? notes[0].description : "",
          noteId: notes.length > 0 ? notes[0]._id : "",
          tags: data.tags ? data.tags : [],
          is_prorata: data.is_prorata,
          is_lead_investor: data.is_lead_investor,
          board_seat: data.board_seat,
          information_rights: data.information_rights,
          portfolio_item: this.currentCompany._id,
          workspace: this.currentCompany.workspace,
          currentValue: data.currentValue?data.currentValue:'',
          proceeds_amount: data.proceeds_amount
        }
      };
    },
    getPeopleData() {
      api
        .get(`portfolio/peoples/${this.currentCompany._id}`)
        .then(data => {
          this.peopleData = data.data.encrypt.success;
        })
        .catch(err => console.log(err));
    },
    getFundingData() {
      let funding_rounds = api
        .get(
          `/offering/${this.currentCompany.organization}/${this.currentCompany._id}`
        )
        .then(data => {
          return Promise.resolve(data.data.encrypt.data);
        })
        .catch(err => console.log(err));
      funding_rounds.then(data => {
        this.offerings = data;
        return data;
      });
    },
    getInvestmentData() {
      api
        .get(`/portfolio/investments/${this.currentCompany._id}`)
        .then(data => {
          this.investmentData = data.data.encrypt.success;
          if (this.showSpinner) {
            this.investmentTabulator.updateData(this.investmentData);
            this.$toaster.success("Deleted successfully.");
            this.handleCancelDeleteInvestment();
          }
        })
        .catch(err => console.log(err));
    },
    getReferrers() {
      let payload = {
        diligenceId: "",
        portfolioItem: ""
      };
      payload.portfolioItem = this.currentCompany._id;
      if (this.currentCompany && this.currentCompany.diligenceId)
        payload.diligenceId = this.currentCompany.diligenceId;
      api
        .post(`/portfolio/referrers`, { encrypt: { data: payload } })
        .then(data => {
          this.referralsData = data.data.encrypt.success[0];
        })
        .catch(err => console.log(err));
    },
    refreshNotesCard() {
      let self = this;

      self.refreshNotes = false;
      setTimeout(() => {
        self.refreshNotes = true;
      }, 100);
    },
    refreshDocumentsCard() {
      let self = this;

      self.refreshDocuments = false;
      setTimeout(() => {
        self.refreshDocuments = true;
      }, 100);
    },
    refreshInvestments(data) {
      if (data) {
        this.investmentData = data;
      }
      this.getFundingData();
    },
    refreshInvestmentsData(data) {
      this.getInvestmentData();
    },
    handleEditCompany() {
      let propsData = JSON.parse(JSON.stringify(this.currentCompany));
      propsData.initial_investment =
        propsData.initial_investment && propsData.initial_investment != "-"
          ? propsData.initial_investment
          : "";
      propsData.name =
        propsData.name && propsData.name != "-" ? propsData.name : "";
      propsData.logo_url =
        propsData.logo_url && propsData.logo_url != "-"
          ? propsData.logo_url
          : "";
      propsData.category_data =
        propsData.category_data && propsData.category_data != "-"
          ? Array.from(new Set(propsData.category_data.split(","))).toString()
          : "";
      propsData.sector =
        propsData.sector && propsData.sector != "-" ? propsData.sector : "";
      propsData.founding_date =
        propsData.founding_date &&
        propsData.founding_date != "-" &&
        propsData.founding_date != "Invalid date"
          ? propsData.founding_date
          : "";
      propsData.stage_i_invested =
        propsData.stage_i_invested && propsData.stage_i_invested != "-"
          ? propsData.stage_i_invested
          : "";
      propsData.company_type =
        propsData.company_type && propsData.company_type != "-"
          ? propsData.company_type
          : "";
      propsData.last_funding_round =
        propsData.last_funding_round && propsData.last_funding_round != "-"
          ? propsData.last_funding_round
          : "";
      if (propsData.last_funding_round == "-") {
        propsData.last_funding_round = "";
      }
      propsData.geography =
        propsData.geography && propsData.geography != "-"
          ? propsData.geography
          : "";
      propsData.employee_count =
        propsData.employee_count && propsData.employee_count != "-"
          ? propsData.employee_count
          : "";
      propsData.website =
        propsData.website && propsData.website != "-" ? propsData.website : "";
      propsData.contact_email =
        propsData.contact_email && propsData.contact_email != "-"
          ? propsData.contact_email
          : "";
      propsData.facebook =
        propsData.facebook && propsData.facebook != "-"
          ? propsData.facebook
          : "";
      propsData.linkedin =
        propsData.linkedin && propsData.linkedin != "-"
          ? propsData.linkedin
          : "";
      propsData.twitter =
        propsData.twitter && propsData.twitter != "-" ? propsData.twitter : "";
      propsData.description =
        propsData.description && propsData.description != "-"
          ? propsData.description
          : "";

      propsData.referred_by = this.referralsData;
      this.editCompanyModalProps = {
        isShow: true,
        data: propsData
      };
      this.showEditModalPopup = true;
    },
    updatePortfolioValue(id){
      api.patch(`/updatePortfolioValue/${id}`).then((res)=>{
        // console.log("data : ", res);
      }).catch(err => {
        console.error("error updating portfolio value : ", err);
      })
    },
    handleCancelDeleteInvestment() {
      this.deleteFlag = false;
      this.deleteInvestmentData = {};
      this.showSpinner = false;
    },
    async handleDeleteInvestment(data) {
      let self = this;
      this.showSpinner = true;
      let param = data;
      this.$store
        .dispatch("investment/deleteInvestment", data)
        .then(async data => {
          // this.getInvestmentData();
          // this.$refs.noteRef.getNotes();
          let index = self.investmentData.findIndex(item => {
            return item._id == param._id;
          });
          if (
            (param.amount && param.amount.length > 0) ||
            (param.equity_standing &&
              param.equity_standing.value &&
              param.equity_standing.value.length > 0) ||
            index == 0
          ) {
            let serverData = {};
            if (param.amount && param.amount.length > 0) {
              serverData.cost =
                this.currentCompany.cost > 0
                  ? Number(
                      (this.currentCompany.cost - Number(param.amount)).toFixed(
                        1
                      )
                    )
                  : 0;
              serverData.cost = serverData.cost < 0 ? 0 : serverData.cost;
            }
            serverData._id = this.currentCompany._id;
            serverData.__v = this.currentCompany.__v;
            if (
              param.equity_standing &&
              param.equity_standing.value &&
              param.equity_standing.value.length > 0
            ) {
              serverData.ownership =
                this.currentCompany.ownership > 0
                  ? this.currentCompany.ownership -
                    Number(Number(param.equity_standing.value).toFixed(1))
                  : 0;
              serverData.ownership =
                serverData.ownership > 100 ? 100 : serverData.ownership;
              serverData.ownership =
                serverData.ownership < 0 ? 0 : serverData.ownership;
            }
            if (self.investmentData.length > 1 && index == 0) {
              serverData.initial_investment = self.investmentData[1].date;
            }
            if (self.investmentData.length == 1) {
              serverData.initial_investment = "";
            }
            // let investmentOwnershipData = this.investmentData.filter(item => {
            //   return item._id != param._id;
            // });
            // if (param.equity_standing && param.equity_standing.value) {
            //   let ownership = 0;

            //   if (investmentOwnershipData.length > 0) {
            //     for (var i = investmentOwnershipData.length - 1; i >= 0; i--) {
            //       if (
            //         investmentOwnershipData[i]._id != param._id &&
            //         investmentOwnershipData[i].equity_standing &&
            //         Number(investmentOwnershipData[i].equity_standing.value) > 0
            //       ) {
            //         ownership = Number(
            //           investmentOwnershipData[i].equity_standing.value
            //         );
            //         break;
            //       }
            //     }
            //   }
            //   serverData.ownership = ownership;
            // }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                   self.updatePortfolioValue(serverData._id);
                  // ownerShipCheck
                  //   ? this.$toaster.success("Cost and Ownership updated")
                  //this.$toaster.success("Cost Updated");
                  //return;
                });
            });
          }
          let uploadedDocs = await this.$store.getters[
            "file/filesByInvestmentId"
          ](param._id);
          let delCounter = 0;
          if (uploadedDocs.length == 0) {
            //this.showSpinner = false;
            //this.deleteFlag = false;
            this.getInvestmentData();
            this.$refs.noteRef.getNotes();
            this.attachments;
            //this.$toaster.success("Deleted successfully.");
            //this.handleCancelDeleteInvestment();
          } else {
            _.forEach(uploadedDocs, async item => {
              if (item) {
                let k = await self.$store
                  .dispatch("file/deleteFile", item._id)
                  .then(
                    item => {
                      delCounter++;
                      self.$store.dispatch("file/start", null, { root: true });
                    },
                    error => {
                      delCounter++;
                      //this.isSaving = false;
                    }
                  );
                if (uploadedDocs.length == delCounter) {
                  //this.showSpinner = false;
                  //this.deleteFlag = false;
                  this.getInvestmentData();
                  this.$refs.noteRef.getNotes();
                  this.attachments;
                  //this.$toaster.success("Deleted successfully.");
                  // this.handleCancelDeleteInvestment();
                }
              }
            });
          }
          //this.$toaster.success("Deleted successfully.");
          //this.handleCancelDeleteInvestment();
        })
        .catch(err => {
          this.$toaster.error("Fail to delete.");
          console.log("error in delete investment", err);
          this.handleCancelDeleteInvestment();
        });
    },
    getInvestmentTabulatorDetails(list) {
      this.investmentTabulator = list;
    },
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    sendEmail() {
      let self = this;

      let selectedChecklistItemIds = [];
      self.portfolioChecklist.forEach(item => {
        if (item.sendInShare) {
          selectedChecklistItemIds.push(item._id);
        }
      });


      this.SharingCompanySubmit = true;
      let serverData = {};
      serverData.emails = this.tags;
      serverData.note = this.sharingNote;
      serverData.permalink = this.currentCompany.permalink;
      serverData.organization = this.currentCompany.organization;
      serverData.component = "Portfolio link from profile";
      serverData.account = this.$route.params.account_id;
      serverData.company = this.currentCompany.name;
      let userName = self.$store.getters["user/user"];
      let userNameString =
        userName.firstName != userName.lastName
          ? `${userName.firstName} ${userName.lastName} `
          : userName.lastName;
      serverData.senderName = userNameString;
      serverData.selectedChecklistItemIds = selectedChecklistItemIds;
      fetch(`${config.API_URL}/sharePortfolio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          data: serverData
        })
      })
        .then(res => res.json())
        .then(data => {
          this.sentDealMethod(serverData);
        });
    },
    sentDealMethod(payload) {
      let self = this;
      if (payload.emails && payload.emails.length > 0) {
        let sentDealPayload = {
          name: payload.company ? payload.company : "",
          permalink: payload.permalink ? payload.permalink : "",
          logo: self.currentCompany.logo_url
            ? self.currentCompany.logo_url
            : "",
          sector: self.currentCompany.sector ? self.currentCompany.sector : "",
          note: payload.note ? payload.note : "",
          organization: self.currentCompany.organization,
          emails: payload.emails,
          sent_by: self.$route.params.account_id
        };
        self.$store
          .dispatch("referrer/apiPostSentDeal", sentDealPayload)
          .then(data => {
            self.$toaster.success("Email will be sent shortly...");
            self.SharingCompanySubmit = false;
            self.shareCompanyModalShow = false;
            self.tags = [];
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getValuationTabulatorDetails(list) {
      this.valuationTabulator = list;
    },
    getValuationsData() {
      const self = this;
      // api
      //   .get(
      //     `/${this.$route.params.workspace_id}/${this.currentCompany._id}/valuation`
      //   )
      //   .then((data) => {
      self.$store
        .dispatch("rounds/apiFetchRounds")
        .then(data => {
          this.valuationData = self.$store.getters[
            "rounds/roundsByPortfolioId"
          ](self.currentCompany._id);
          this.handleCancelValuationDialog();
          this.handleCancelDeleteValuation();
        })
        .catch(error => {
          console.log("error in fetching valuations", error);
        });

      // })
      // .catch((error) => {
      //   console.log("error in fetching valuations", error);
      // });
    },
    handleCancelValuationDialog() {
      this.valuationDialogTitle = "";
      this.valuationDialogShow = false;
      this.showValuationSpinner = false;
      this.valuationDialogData = {};
    },
    handleCreateValuation() {
      let previous_round;
      if (this.valuationData && this.valuationData.length > 0) {
        previous_round = this.valuationData[this.valuationData.length - 1];
      }
      this.dialogValuationRound = {
        isCreate: true,
        data: {
          isParticipated: false,
          isVerified: false,
          date: moment(new Date()),
          company_name: this.currentCompany.name,
          portfolio_item: this.currentCompany._id,
          workspace: this.currentCompany.workspace,
          investment_type: "SAFE Note",
          transaction_date: new Date(),
          currentValue: this.currentCompany.value
        },
        isShow: true,
        portfolio_item:
          this.currentCompany && this.currentCompany._id
            ? this.currentCompany._id
            : "",
        previous_round: previous_round ? previous_round : {},
        currentCompany: this.currentCompany
      };
    },
    formatCurrency: formatCurrency,
    handleEditValuation(valuationData) {
      let previous_round;
      let index = this.valuationData.findIndex(
        item => item._id == valuationData._id
      );
      if (index >= 1) {
        previous_round = this.valuationData[index - 1];
      }
      this.dialogValuationRound = {
        isCreate: false,
        data: JSON.parse(JSON.stringify(valuationData)),
        isShow: true,
        portfolio_item:
          this.currentCompany && this.currentCompany._id
            ? this.currentCompany._id
            : "",
        previous_round: previous_round ? previous_round : {}
      };
    },
    handleCancelDeleteValuation() {
      this.showDeleteValuationDialog = false;
      this.showValuationDeleteSpinner = false;
      this.deleteValuationData = {};
    },
    handleDeleteValuation(valuationData) {
      let self = this;
      if (valuationData._id) {
        this.showValuationDeleteSpinner = true;
        self.$store
          .dispatch("rounds/apiDeleteRounds", valuationData._id)
          .then(data => {
            self.valuationData = self.$store.getters[
              "rounds/roundsByPortfolioId"
            ](self.currentCompany._id);
            self.$toaster.success("Deleted Successfully.");
            self.handleCancelValuationDialog();
            self.handleCancelDeleteValuation();
          })
          .catch(error => {
            self.$toaster.error("Failed to delete round !!!");
          });
      }
    },
    sendKpiEmail(data) {
      let investorPublicUrl = `http://localhost:8080/#/investors?p=${this.currentCompany._id}`;
      let emailBody = `<!DOCTYPE html>
      <html>

<head>
    <title>Fiifi | Updates</title>
    <style type="text/css">
        @media only screen and (max-width: 700px) {
            .full-width-container {
                padding: 0 !important;
            }

            .container {
                width: 100% !important;
            }
        }
    </style>
</head>

<body style="padding: 0; margin:0px; font-family: Roboto;">
    <table border="0" align="center" cellpadding="0" cellspacing="0" width="100%" style="width: 100%; Margin:0 auto;">
        <tr>
            <td style="font-size: 0;">&nbsp;</td>
            <td align="center" valign="top" style="width: 600px;">
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                        <td align="center" valign="top">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%"
                                style="background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #0000001A;border-radius: 5px 5px 0px 0px;opacity: 1;">
                                <tr>
                                    <td align="center">
                                        <table class="container" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            height="70" style="background-color:#593BFD;height: 70px;">
                                            <tr>
                                                <td style="text-align: center; padding: 15px 0px 15px 0px">
                                                    <img style="height:40px;width:75px"
                                                        src="https://assets.fiifi-dev.com/logo.png">
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div style='margin:26px 30px 70px 30px;text-align: left;
font-size:18px;
line-height:26px;
letter-spacing: 0px;
color: #000000;
opacity: 0.5;'>
                                            Hello name,
                                            <br><br>
                                            Someone has added your company to their fiifi profile. Lorem Ipsum has been
                                            the industry's standard dummy text ever since the 1500.Lorem Ipsum has been
                                            the industry's standard dummy text ever since the 1500.Lorem Ipsum has been
                                            the industry's standard dummy text ever since the 1500. Lorem Ipsum has been
                                            the industry's standard email.Lorem Ipsum has been the industry's standard
                                            dummy text ever since the 1500.Lorem Ipsum has been the industry's standard
                                            dummy text ever since the 1500.
                                            <div style='margin-top:66px'>
                                                <div style='display:flex;margin:auto;width: 310px;
height: 45px;
background-color: #78DE87;
border-radius: 3px;
opacity: 1;cursor:pointer'>
                                                    <div style='display:flex;margin:auto;text-align: center;
font-size:18px;
line-height:24px;
letter-spacing: 0px;
color: #000000;
opacity: 1;'>
                                                        <a href='${investorPublicUrl}' target='_blank'
                                                            style='text-decoration:none;color:#000'>
                                                            Investor List
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td align="center" valign="top">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%"
                                style="background: #EAEDFA 0% 0% no-repeat padding-box;border: 1px solid #0000001A;opacity: 1;padding: 30px 40px;border-spacing: 0;">
                                <tr>
                                    <td align="center" valign="top">
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            style="border-spacing: 0;">
                                            <tr>
                                                <td style="font-size: 0;">&nbsp;</td>
                                                <td align="center" style="width: 210px;">
                                                    <table align="center" border="0" cellpadding="0" cellspacing="20"
                                                        width="100%" style="border-spacing: 0;">
                                                        <tr>
                                                            <td align="left" style="width: 50px;padding: 0;">
                                                                <a target="_blank"
                                                                    href="https://www.linkedin.com/company/fiifi/">
                                                                    <img src="https://assets.fiifi-dev.com/linkedin.png"
                                                                        style="display:block;margin: 0px;width: 30px; height: 30px;">
                                                                </a>
                                                            </td>
                                                            <td align="left" style="width:50px;padding: 0px">
                                                                <a target="_blank"
                                                                    href="https://www.instagram.com/fiifi.co/?hl=en">
                                                                    <img src="https://assets.fiifi-dev.com/instagram.png"
                                                                        style="display:block;margin: 0px;width: 30px; height: 30px;">
                                                                </a>
                                                            </td>
                                                            <td align="left" style="width: 50px;padding: 0px">
                                                                <a target="_blank"
                                                                    href="https://twitter.com/search?q=%7Bfiifi.co%7D&src=typed_query">
                                                                    <img src="https://assets.fiifi-dev.com/twitter.png"
                                                                        style="display: block;margin: 0px;width: 30px; height: 30px;">
                                                                </a>
                                                            </td>
                                                            <td align="left" style="width:50px;padding: 0px">
                                                                <a target="_blank" href="https://fiifi.co/blog/">
                                                                    <img src="https://assets.fiifi-dev.com/blog.png"
                                                                        style="display:block;margin: 0px;width: 60px; height: 30px;">
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td style="font-size: 0;">&nbsp;</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <!--tr>
                                    <td style="font-size: 0;">&nbsp;</td>
                                    <td align="center" style="padding-left: 40px;">
                                        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding-top: 15px;">
                                            <tr>
                                                <td style="padding-right: 20px;font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;">
                                                    <a>Upgrade</a>
                                                </td>
                                                <td style="white-space: nowrap; padding-right: 20px;font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;">
                                                    <a>Learn more</a>
                                                </td>
                                                <td style="opacity: 0.8;font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;">
                                                    <a>Unsubscribe</a>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td style="font-size: 0;">&nbsp;</td>
                                </tr-->
                                <tr>
                                    <td align="center" valign="top">
                                        <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                            <tr>

                                                <td
                                                    style="border-bottom: 1px solid #000000;opacity: 0.2;padding-top: 30px;">
                                                </td>

                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" valign="top">
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            style="border-spacing: 0;">
                                            <tr>
                                                <td style="font-size: 0;">&nbsp;</td>
                                                <td align="center" style="width: 278px;">
                                                    <table border="0" cellpadding="0" cellspacing="0" width="100%"
                                                        style="padding-top: 30px;border-spacing: 0;">
                                                        <tr>
                                                            <td align="left" style="width:61px;white-space: nowrap;">
                                                                <a style="font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;"
                                                                    href="https://fiifi.co/pricing/">Pricing</a>
                                                            </td>
                                                            <td align="left" style="width:64px;white-space: nowrap;">
                                                                <a style="font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;"
                                                                    href="https://fiifi.co/support/">Support</a>
                                                            </td>
                                                            <td align="left" style="width:83px;white-space: nowrap;">
                                                                <a style="opacity: 0.8;font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;"
                                                                    href="https://fiifi.co/fiifi-contact-us/">Contact Us</a>
                                                            </td>
                                                            <td align="left" style="width:70px;white-space: nowrap;">
                                                                <a style="opacity: 0.8;font-style: normal;font-variant: normal;font-weight: 400;font-size: 14px;line-height: 20px;letter-spacing: 0px;color: #000000;opacity: 0.5;text-decoration: underline;"
                                                                    href="https://app.fiifi.co/#/login?up={{ entity.uuid }}">Unsubscribe</a>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td style="font-size: 0;">&nbsp;</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center" valign="top">
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            style="border-spacing: 0;">
                                            <tr>
                                                <td style="font-size: 0;">&nbsp;</td>
                                                <td align="center" style="width: 272px;">
                                                    <table border="0" cellpadding="0" cellspacing="0" width="100%"
                                                        style="padding-top: 25px;border-collapse: separate;border-spacing: 0;">
                                                        <tr>
                                                            <td align="center"
                                                                style="padding: 0px; padding-bottom: 0px;font-style: normal;font-variant: normal;font-weight: 400;font-size: 12px;line-height: 28px;letter-spacing: 0px;color: #000000;opacity: 0.5;">
                                                                Copyright © 2020 fiifi. All rights reserved.
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td align="center"
                                                                style="padding: 0px;white-space: nowrap;font-style: normal;font-variant: normal;font-weight: 400;font-size: 12px;line-height: 28px;letter-spacing: 0px;color: #000000;opacity: 0.5;">
                                                                We are sending email to people that signed up for
                                                                &nbsp;<a align="center"
                                                                    style="padding: 0px;color:#593BFD;cursor: pointer; text-decoration: none;font-style: normal;font-variant: normal;font-weight: 400;font-size: 12px;line-height: 28px;letter-spacing: 0px;opacity: 0.95;"
                                                                    href="https://fiifi.co/" target="_blank">fiifi</a>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td style="font-size: 0;">&nbsp;</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
            <td style="font-size: 0;">&nbsp;</td>
        </tr>
    </table>
</body>

</html>`;
      return api.post("/generic/send/email", {
        encrypt: {
          data: {
            emails: ["gandhar@gytworkz.com"],
            subject: "KPI Email",
            html: emailBody
          }
        }
      });
    },

    openAcquisitionCompany() {
      let self = this;

      self.$router.push(
        `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${self.currentCompany.acquisition_info.acquisitionCompanyUcId}`
      );
      self.init();
      self.refreshNotesCard();
      self.refreshDocumentsCard();
    },
    openAcquiredCompany(ucid) {
      let self = this;

      self.$router.push(
        `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
      );
      self.init();
      self.refreshNotesCard();
      self.refreshDocumentsCard();
    },

    handleIpoEdit() {
      this.$refs.companyCard.showEditIPO();
    },
    handleAcquisitionEdit() {
      this.$refs.companyCard.showEditAcquisition();
    },

    init() {
      this.$store.commit("todo/setCurrentComponent", "portfolio");
      this.editRoute = `#/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio/edit/${this.$route.params.ucid}`;
      if (
        document.querySelector(".barChart") &&
        document.querySelector(".barChart").style &&
        document.querySelector(".barChart").style.width
      ) {
        document.querySelector(".barChart").style.width = 100 + "%";
      }
      const titleEl = document.querySelector("head title");

      titleEl.textContent = `Fiifi`;

      if (this.currentCompany) {
        titleEl.textContent = `Fiifi | ${this.currentCompany.name}`;
        const self = this;
        setTimeout(() => {
          self.getInvestmentData();
        }, 10);
        // self.getValuationsData();
        if (this.currentCompany.permalink) {
          api
            .get(
              `/portfolio/newsFeed/${this.currentCompany.permalink}/${this.currentCompany.name}`
            )
            .then(data => {
              if (
                data.data &&
                data.data.encrypt &&
                data.data.encrypt.success &&
                data.data.encrypt.success[0] &&
                data.data.encrypt.success[0][0]
              ) {
                let list = [];
                let newsList = data.data.encrypt.success[0][0];
                if (newsList.data_cb_permalink.status) {
                  newsList.data_cb_permalink.feed.map(item => list.push(item));
                }
                if (newsList.data_rss_company_name.status) {
                  newsList.data_rss_company_name.feed.map(item =>
                    list.push(item)
                  );
                }
                self.newsFeedList = list.sort((a, b) => {
                  return new Date(b.time) - new Date(a.time);
                });
              }
            })
            .catch(err => {
              console.log({ err });
            });
        }
      }
      //get offering details
      if (this.currentCompany && this.currentCompany.organization) {
        // this.getPeopleData();
        this.getFundingData();
      } else {
        // console.log(this.currentCompany);
      }

      // if (this.currentCompany.user_investment_status == "Diligence")
      if (this.currentCompany) {
        this.getReferrers();
      }
      // get people/attachments for company
      //this.$store.dispatch("people/apiFetchPeople");
      // this.$store.dispatch("attachment/apiFetchAttachment");
      // initailize some data
      this.notes =
        this.currentCompany && this.currentCompany.notes
          ? this.currentCompany.notes
          : "";

      // fetch address for this company
      // this.$store
      //   .dispatch(`address/${ADDRESS_FETCH}`, {
      //     force: true,
      //     parent: this.currentCompany._id
      //   })
      //   .then(res => {})
      //   .catch(err => {});
    },
    statusChangePermission() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;

      let index = rolePermissions.findIndex(item => {
        if (item == "EDIT COMPANY STATUS") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    calculateLockupDaysRemaining(k) {
      let self = this;
      if (self.currentCompany.ipo_info.ipoDateSold) {
        let addedDate = moment(self.currentCompany.ipo_info.ipoDateSold).add(
          self.currentCompany.ipo_info.ipoPeriod,
          "days"
        );
        let curDate = moment();

        let difInDays = addedDate.diff(curDate, "days");
        return difInDays > 0 ? difInDays : 0;
      }

      return 0;
    },
    getChecklistItems() {
      let self = this;
      self.$store
        .dispatch("checklist/apiFetchChecklist")
        .then(async () => {
          self.getChecklistByPortfolio();
        })
        .catch(error => {
          console.log("error in fetching checklist", error);
        });
    },
    handleCreateChecklist() {
      this.isShowAddChecklist = true;
    },
    getChecklistByPortfolio() {
      let self = this;
      if (self.currentCompany) {
        let portfolioChecklist = self.$store.getters[
          "checklist/checklistByPortfolioId"
        ](self.currentCompany._id);
        // console.log('portfolio checklist' )
        self.portfolioChecklist = portfolioChecklist || [];
      }
    },
    completedChecklistItemCount(clItems) {
      return clItems.filter(item => {
        return item.is_done;
      }).length;
    },
    toggleChecklist(checklist) {
      checklist.show = !checklist.show;
      this.portfolioChecklist = [...this.portfolioChecklist];
    },
    handleCancelChecklistCreate() {
      this.newChecklist = "";
      this.newChecklistCopyFromExisting = "";

      this.isShowAddChecklist = false;
      console.log("portfolio_item : ", this.currentCompany._id);
    },
    async handleSaveChecklist() {
      let self = this;

      self.showSaveChecklistLoader = true;

      let copiedChecklist = [];

      if (self.newChecklistCopyFromExisting) {
        let found = self.accountChecklist.find(item => {
          return item._id == self.newChecklistCopyFromExisting;
        });

        if (found) {
          copiedChecklist = found.checklist_items.map((clItm, idx) => {
            return {
              id: Date.now() + "_" + idx,
              summary: clItm.summary,
              is_done: false,
              discussions: []
            };
          });
        }
      }

      self.$store
        .dispatch("checklist/apiPostChecklist", {
          portfolio_item: self.currentCompany._id,
          name: self.newChecklist,
          copiedChecklistItems: copiedChecklist
        })
        .then(() => {
          self.getChecklistItems();
          self.showSaveChecklistLoader = false;
          self.isShowAddChecklist = false;
        })
        .catch(err => {
          console.log("err: ", err);
          self.showSaveChecklistLoader = false;
        });
    },
    handleChecklistNameClick(checklist) {
      let self = this;
      self.$router.push(
        `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/checklist/${self.currentCompany._id}/${self.$route.params.ucid}/${checklist._id}`
      );
    },
    async handleCheck(item, checklist, isDone) {
      let self = this;
      self.showSaveCheck = true;
      self.currentItemId = item.id;

      item.is_done = isDone;

      try {
        await api.put(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/${self.currentCompany._id}/checklist/${checklist._id}/checklist_item/${item.id}`,
          {
            encrypt: {
              data: {
                is_done: isDone
              }
            }
          }
        );

        // self.getChecklistItems();
      } catch (e) {
        console.log("error: ", e);
      }

      self.showSaveCheck = false;
      self.currentItemId = "";
    },
    hideShareDialog() {
      this.portfolioChecklist.forEach(item => {
        item.sendInShare = false;
      });
      this.shareCompanyModalShow = !this.shareCompanyModalShow;
    },
    getWorkspaceOwner(){
      api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/workspaceOwner`).then((res) => {
        this.workspaceOwner = res.data.encrypt.success;
      }).catch((err) => {console.log(err)});
    },
  },
  created() {
    this.getAllChecklist()
  },
  mounted() {
    this.init();
    this.getChecklistItems();
    this.getValuationsData();
    this.getWorkspaceOwner();
  },
  watch: {
    currentCompany: {
      handler() {
        if (this.currentCompany) {
          this.getChecklistByPortfolio();
        }
      }
    },
    portfolioChecklist: {
      handler(a, b) {}
    },
  } 
};
</script>
<style lang="scss">
.dilignce-el-select .el-input .el-input__inner {
  text-align: left;
  padding-left: 0px;
  text-overflow: ellipsis;
}
.dilignce-el-select1 .el-input .el-input__inner {
  text-align: left;
  padding-left: 0px;
  padding-right: 0px !important;
  text-overflow: ellipsis;
}
// .dilignce-el-select .el-input__suffix-inner {
//   // padding-right: 30px;
// }
.investment-card,
.chart-card,
.company-card,
.contacts-card {
  height: calc(100% - 30px);
}

.edit-button {
  color: #707070 !important;
  font-size: 14px;
  cursor: pointer;
}

.delete-button {
  color: #e04b4b !important;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
}

.notes-box {
  width: 100%;
  min-height: 200px;
  border-color: #dfdfdf;
  cursor: default;
}

.notes-box:focus {
  outline: none !important;
  border-color: #dfdfdf;
}

.investment-stat-title,
.investment-stat-val {
  font-size: 14px;
  font-weight: 600;
}
.investment-stat-val {
  font-weight: normal;
  color: #848484;
}

.investment-stat {
  display: flex;
  justify-content: space-between;
  padding: 3px;
}

.download {
  margin-right: 20px;
}

.investment-stats div:nth-child(odd) {
  background: #e6e6e6;
}

.links-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.company-edit-buttons {
  width: 46px;
  text-align: right;
}

.title-wrapper {
  display: flex;
  margin: 0;
  margin-top: 20px;
  flex-direction: row;

  .main-title {
    margin: 0px 0 10px;
    font-weight: 400;
    color: #707070;
  }

  .spacer {
    flex: 1 1 auto;
  }
}

.left {
  text-align: left;
}
th {
  width: 20%;
  font-size: 14px;
}

.field-content {
  color: #9f9f9f;
}

.warn-data-status {
  color: #fea012;
  font-weight: bold;
  font-size: 12px;
  i {
    background-color: #fea012;
    color: #fff;
    padding: 2px;
    border-radius: 100%;
    font-weight: bolder;
    box-sizing: border-box;
    display: inline-block;
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
  }
}
.equal-column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  height: 100%;
}

.invst-val {
  width: 100%;
  height: 42px;
  text-align: left;
  font: bold 35px/1.5 sans-serif;
  letter-spacing: 0;
  // color: #434343;
  text-align: center;
  opacity: 1;
}
.invst-label {
  width: 100%;
  height: 17px;
  text-align: left;
  font: 14px/1.5 sans-serif;
  letter-spacing: 0;
  // color: #434343;
  text-align: center;
  opacity: 1;
}
.invst-wrp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  justify-content: space-between;
  flex-wrap: wrap;
}
.invst .card-body {
  display: flex;
  flex-direction: column;
}
.invst-box {
  min-width: 100px;
  min-width: 140px;
  flex: 1 1 auto;
}
.dim-text {
  font-size: 12px;
  color: #808080;
}

.links-card .card-body {
  max-height: 295px;
  overflow: auto;
  margin-bottom: 10px;
}

.tabulator {
  .normal-data-status {
    font-weight: bold;
    font-size: 12px;
    i {
      margin-right: 6px;
    }
  }
  .warn-data-status {
    color: #fea012;
    font-weight: bold;
    font-size: 12px;
    i {
      background-color: #fea012;
      color: #fff;
      padding: 2px;
      border-radius: 100%;
      font-weight: bolder;
      box-sizing: border-box;
      display: inline-block;
      width: 17px;
      height: 17px;
      display: inline-block;
      text-align: center;
    }
  }
  .success-data-status {
    color: #79c566;
    font-weight: bold;
    font-size: 12px;
    i {
      background-color: #79c566;
      color: #fff;
      padding: 2px;
      border-radius: 100%;
      font-weight: bolder;
      box-sizing: border-box;
      display: inline-block;
    }
  }
}
.traction-line {
  font-size: 14px;
  line-height: 14px;
  color: #9b9b9b;
  vertical-align: middle;
}
.arrow-amount {
  &.fa {
    font-size: 22px;

    &.fa-arrow-down {
      color: #fd3f3f;
    }

    &.fa-arrow-up {
      color: #66bd51;
    }
  }
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.add-icon {
  position: absolute;
  top: 22px;
  right: 15px;
  cursor: pointer;
  color: #707070;
}

.arrowAdjustment .tabulator-arrow {
  margin-top: 10px !important;
}

.companyProfileTabulatorInvestFundTable .card-header {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.companyTagCls {
  background: #e8e7fb 0% 0% no-repeat padding-box;
  border: 1px solid #cdccfa;
  border-radius: 15px;
  opacity: 1;
}

.v-switch-label {
  color: #000 !important;
}

.notParticipated {
  background-color: #a6a6df !important;
}

.label {
  width: 300px;
}
.info-section {
  .value:before {
    content: ":";
    display: inline-block;
    top: 0;
    z-index: 2;
    padding-right: 5px;
  }
}
.acquired-company-pill {
  min-width: 188px;
  height: 30px;
  background: #dcdbfe;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: HelveticaNeue;
  letter-spacing: 0px;
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-left: 15px;
  padding: 0 20px;

  .link {
    font-size: inherit;
  }
}

.checklist-card.half {
  max-width: 50%;
}

.checklist-card {
  .card-body {
    padding-top: 0;
  }

  .checklist-row {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
    .summary {
      align-items: center;
    }
    .name-wrapper {
      margin: 10px 0 5px 0;

      .name {
        text-align: left;
        font-size: 14px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
        margin-right: 8px;
      }
      .date {
        text-align: left;
        font-size: 12px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #00000080;
        opacity: 1;
      }
    }
    .count {
      text-align: left;
      font-size: 10px;
      line-height: 1.5;
      letter-spacing: 0px;
      color: #00000080;
      opacity: 1;
    }
    .progress-wrapper {
      .progress-outer {
        width: 209px;
        height: 15px;
        background: hsla(0, 0%, 0%, 0.2) 0% 0% no-repeat padding-box;
        border-radius: 10px;
        .progress {
          background: hsla(245, 88%, 61%, 0.85) 0% 0% no-repeat padding-box;
          border-radius: 10px;
          height: 100%;
          text-align: center;

          width: 75%;
          text-align: center;
          line-height: 1.5;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }

      .arrows {
        margin-left: 10px;
      }
    }

    .details {
      .checklist-item-row {
        align-items: flex-start;
      }
      .checkbox {
        // background: #ffffff 0% 0% no-repeat padding-box;
        // border: 1px solid #000000;
        border-radius: 3px;
        opacity: 1;
        margin-right: 10px;
        width: 18px;
        height: 18px;
      }
      .checklist-item {
        text-align: left;
        font-size: 14px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #000000;
        opacity: 0.5;
      }
      .comment-total {
        text-align: left;
        font-size: 12px;
        line-height: 1.5;
        letter-spacing: 0px;
        color: #5445f3;
        opacity: 1;
        min-width: 32px;
      }
    }
  }

  .no-data-msg {
    font-size: 10px;
    opacity: 0.2;
  }
}
.checklist-el-select.el-select {
  input {
    border: 1px solid black;
    border-radius: 4px;
    padding: 2px 5px;
  }
}

.btn-wrapper {
  padding-right: 25px;
  margin-top: 20px;
  padding-right: 0;
}
.checklist-share-help {
  text-align: left;
  font-size: 13px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.5;
  margin-left: 22px;
}

.icon {
  position: relative;
  display: inline-block;
  margin-top: auto;
  margin-bottom: 20px; 
  display: inline-block; 
  margin-left: 10px;
  display: relative;
}

.icon .customToolTip {
  visibility: hidden;
  width: 210px;
  background-color: #363f55;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 5px;
  position: absolute;
  z-index: 100;
  top:-10%;
  left: -157px;
  margin-left: -60px;
}

.icon .customToolTip::after {
  content: " ";
  position: absolute;
  top: 23%;
  left: 100%; /* To the right of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #363f55 transparent transparent transparent;
  transform: rotate(-90deg);
}

.icon:hover .customToolTip {
  visibility: visible;
}

#theMainTableBoxMyInvestments{
  .tabulator-row .tabulator-cell{
    overflow: visible ;
  }
  .tabulator-tableHolder {
    overflow-y: auto ;
  }
}


.sizingSelect {
  width: 409px;
}

.editChecklistNameButton{
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
